<template>
  <div class="subject_main" onselectstart="return false;" id="cancelPopover">
    <el-dialog title="两种作业格式" :visible.sync="homeworkDialog" width="41%">
      <div class="flex-row-space-between">
        <div class="homeworkDialogBox flex-col-v-center">
          <div style="margin-bottom: 15px">习题解析结合</div>
          <div class="boxContent">
            <div class="flex-row" style="margin-top: 10px">
              <div>习题:</div>
              <div class="homeworkDialogBoxItem flex-col">
                <el-skeleton :rows="3" animated />
              </div>
            </div>
            <div class="flex-row" style="margin-top: 10px">
              <div>解析:</div>
              <div class="homeworkDialogBoxItem">
                <el-skeleton :rows="3" />
              </div>
            </div>
          </div>

          <div class="boxContent">
            <div class="flex-row" style="margin-top: 10px">
              <div>习题:</div>
              <div class="homeworkDialogBoxItem flex-col">
                <el-skeleton :rows="3" animated />
              </div>
            </div>
            <div class="flex-row" style="margin-top: 10px">
              <div>解析:</div>
              <div class="homeworkDialogBoxItem">
                <el-skeleton :rows="3" />
              </div>
            </div>
          </div>
          <div class="flex-1 flex-center">
            <div class="btn flex-center" @click="download_homework('1')">下载作业</div>
          </div>
        </div>
        <div class="homeworkDialogBox flex-col-v-center">
          <div style="margin-bottom: 15px">习题解析分离</div>
          <div class="boxContent">
            <div class="flex-row" style="margin-top: 10px">
              <div>习题:</div>
              <div class="homeworkDialogBoxItem flex-col">
                <el-skeleton :rows="3" animated />
              </div>
            </div>
            <div class="flex-row" style="margin-top: 10px">
              <div>习题:</div>
              <div class="homeworkDialogBoxItem">
                <el-skeleton :rows="3" />
              </div>
            </div>
          </div>

          <div class="boxContent">
            <div class="flex-row" style="margin-top: 10px">
              <div>解析:</div>
              <div class="homeworkDialogBoxItem flex-col">
                <el-skeleton :rows="3" animated />
              </div>
            </div>
            <div class="flex-row" style="margin-top: 10px">
              <div>解析:</div>
              <div class="homeworkDialogBoxItem">
                <el-skeleton :rows="3" />
              </div>
            </div>
          </div>
          <div class="flex-1 flex-center">
            <div class="btn flex-center" @click="download_homework('2')">下载作业</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 发布作业 -->
    <el-dialog
      title="发布作业"
      :visible.sync="saveHomeWorkDialogVisible"
      width="60%"
      center
    >
      <div class="flex-col saveBox">
        <div class="content_item assign_homework_content_item content_item_margin">
          <div class="content_item_title">发布形式</div>
          <el-radio v-model="structure_type" label="0">在线作业</el-radio>
          <el-radio v-model="structure_type" label="4">无纸化考试</el-radio>
        </div>
        <!-- 选择班级 -->
        <div class="content_item assign_homework_content_item content_item_margin">
          <div class="content_item_title">选择班级</div>
          <el-select
            style="width: 300px"
            v-model="classIds"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="content_item assign_homework_content_item content_item_margin">
          <div class="content_item_title">选择分组</div>
          <el-select
            style="width: 300px"
            v-model="groupIds"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in groupingList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 作业截止时间 -->
        <div class="content_item assign_homework_content_item content_item_margin">
          <div class="content_item_title">截止时间</div>
          <div>
            <el-date-picker
              v-model="datetime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <!-- 批改形式 -->
        <div class="content_item assign_homework_content_item content_item_margin">
          <div class="content_item_title">批改形式</div>
          <el-select v-model="correct_type" placeholder="请选择">
            <el-option label="老师批改" value="0"> </el-option>
            <el-option label="学生互批" value="1"> </el-option>
            <el-option label="学生自批" value="2"> </el-option>
            <el-option label="教师批改（打分卡）" value="5"> </el-option>
            <el-option label="学生自批（打分卡）" value="3"> </el-option>
            <el-option label="学生互批（打分卡）" value="4"> </el-option>
          </el-select>
          <div
            class="content_item_title correct_set"
            v-if="correct_type == 1 || correct_type == 2"
          >
            批改任务截止时间
          </div>
          <div v-if="(correct_type == 1 || correct_type == 2) && structure_type != 4">
            <el-date-picker
              v-model="correct_endtime"
              type="datetime"
              placeholder="请选择批改截止时间"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="content_item assign_homework_content_item content_item_margin">
          <div class="content_item_title">答案发放</div>
          <el-radio v-model="show_answer" label="0">到截止时间/全部批改完毕</el-radio>
          <el-radio v-model="show_answer" label="1">提交作业立马发放</el-radio>
        </div>
        <!-- 作业形式 -->
        <div
          class="content_item assign_homework_content_item content_item_margin"
          v-if="structure_type == 0"
        >
          <div class="content_item_title">任务标签</div>
          <el-radio v-model="useage_type" label="1">作业</el-radio>
          <el-radio v-model="useage_type" label="2">导学</el-radio>
          <el-radio v-model="useage_type" label="3">堂练</el-radio>
          <el-radio v-model="useage_type" label="4">周测</el-radio>
        </div>
        <!-- 答题限时 -->
        <div class="content_item assign_homework_content_item_time content_item_margin">
          <div class="content_item_title">答题限时</div>
          <div>
            <el-switch
              v-model="limit_answer"
              active-color="#69B4FF"
              inactive-color="#cccccc"
            >
            </el-switch>
          </div>
          <div v-if="limit_answer" class="content_item_title correct_set_time">
            限制时间
          </div>
          <div v-if="limit_answer">
            <el-input-number :min="0" v-model="limit_answer_time"></el-input-number>
            <span style="opacity: 0">1</span>
            <span style="color: #999999"> 分钟</span>
          </div>
        </div>
        <!-- 作业要求 -->
        <div class="content_item">
          <div class="content_item_title">作业要求</div>
        </div>
        <!-- textarea 作业要求 -->
        <div class="content_item_remake">
          <el-input
            type="textarea"
            placeholder="请输入内容（选填）......"
            v-model="homework_require"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveHomeWorkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save_assgin">完 成</el-button>
      </span>
    </el-dialog>
    <!-- 导航栏 -->
    <div class="pageNav flex-row-center" v-show="!isPreviewShow">
      <div class="flex-col mar_right">
        <div
          :class="{
            pageNavTitle: true,
            activePageNavTitle: isShowHomeWorkIndex == 1,
          }"
          @click="clickNav('1')"
        >
          布置作业
        </div>
        <div style="height: 5px">
          <div class="pageNavLine" v-show="isShowHomeWorkIndex == 1"></div>
        </div>
      </div>
      <div class="flex-col mar_right">
        <div
          :class="{
            pageNavTitle: true,
            activePageNavTitle: isShowHomeWorkIndex == 2,
          }"
          @click="clickNav('2')"
        >
          批改作业
        </div>
        <div style="height: 5px">
          <div class="pageNavLine" v-show="isShowHomeWorkIndex == 2"></div>
        </div>
      </div>
      <div class="flex-col">
        <div
          :class="{
            pageNavTitle: true,
            activePageNavTitle: isShowHomeWorkIndex == 3,
          }"
          @click="clickNav('3')"
        >
          讲评作业
        </div>
        <div style="height: 5px">
          <div class="pageNavLine" v-show="isShowHomeWorkIndex == 3"></div>
        </div>
      </div>
      <div class="creat_course creatBtn" @click="goPage('1')">新编作业</div>
    </div>
    <div class="wrapper flex-row" v-show="!isPreviewShow && isShowHomeWork">
      <div class="chapter_tree_box">
        <div class="chapter_tree_box_head" v-if="type_second == 'tiku'">
          <div
            @click="
              tab_active_tree_head = 0;
              pageNum = 1;
              get_sourceBag();
            "
          >
            <div
              :style="{
                color: tab_active_tree_head === 0 ? '#69B4FF' : '#333333',
              }"
            >
              章节
            </div>
            <div
              :style="{ opacity: tab_active_tree_head === 0 ? 1 : 0 }"
              class="course_type_line"
            ></div>
          </div>
          <div
            @click="
              tab_active_tree_head = 1;
              pageNum = 1;
              get_sourceBag();
            "
          >
            <div
              :style="{
                color: tab_active_tree_head === 1 ? '#69B4FF' : '#333333',
              }"
            >
              知识点
            </div>
            <div
              :style="{ opacity: tab_active_tree_head === 1 ? 1 : 0 }"
              class="course_type_line"
            ></div>
          </div>
        </div>
        <div class="chapter_tree_box_head_none" v-if="false"></div>
        <div class="chapter_tree_box_trees" v-show="tab_active_tree_head == 0">
          <el-tree
            :data="SectionData"
            :props="SectionProps"
            @node-click="getSectionData"
            node-key="guid"
            :default-expanded-keys="showNode"
            highlight-current
            ref="treeBox"
          >
            <div class="tree_line" slot-scope="{ node, data }">
              <div>{{ node.label }}</div>
              <div v-if="tree_num" style="color: #ff9b36">
                ({{ tree_num[data.c] || 0 }})
              </div>
            </div>
          </el-tree>
        </div>
        <div class="chapter_tree_box_trees" v-show="tab_active_tree_head == 1">
          <el-tree
            :data="newSubject_nodeData"
            :props="newSubject_nodeProps"
            @node-click="getnewSubject"
            node-key="id"
            :default-expanded-keys="showNode_node"
            highlight-current
            ref="treeBox2"
          >
            <div class="tree_line" slot-scope="{ node, data }">
              <div>{{ node.label }}</div>
              <!-- <div style="color:#FF9B36">(999)</div> -->
            </div>
          </el-tree>
        </div>
        <div class="chapter_tree_box_head_none"></div>
      </div>
      <div class="content flex-col">
        <div class="content_nav">
          <div class="btn3Box flex-row">
            <div class="btn3" @click="openPage('1')">学科网</div>
            <div class="btn3" @click="openPage('2')">菁优网</div>
            <div class="btn3" @click="goToResourceSend">我的发布</div>
          </div>
          <div class="flex-row-v-center content_nav_item">
            <!-- <span>类型：</span> -->
            <div
              :class="{
                content_nav_item_btn: true,
                content_nav_item_btn_active: switchTab_task == index,
                'flex-center': true,
              }"
              v-for="(item, index) in switchTabList"
              :key="index"
              @click="switchTabTask(item, index)"
            >
              <span>
                {{ item.name }}
              </span>
            </div>
          </div>
          <div class="flex-row-v-center content_nav_item">
            <!-- <span>来源：</span> -->
            <div
              :class="{
                content_nav_item_btn: true,
                content_nav_item_btn_active: tab_active == index,
                'flex-center': true,
              }"
              v-for="(item, index) in tab_list_resource"
              :key="index"
              @click="switchTab(item, index)"
            >
              <span> {{ item.name }}{{ switchTab_task == 0 ? "作业" : "习题" }} </span>
            </div>
          </div>

          <div
            class="flex-row content_nav_item"
            v-if="switchTab_task == 0 && type_first != 'my'"
          >
            <span>类别：</span>
            <div class="flex-1 flex-row" style="flex-flow: wrap">
              <div
                :class="{
                  content_nav_item_btn: true,
                  content_nav_item_btn_active: switchTab_taskLabel == index,
                  'flex-center': true,
                }"
                v-for="(item, index) in homeworkLabelList"
                :key="index"
                @click="switchHomeworkLabel(item, index)"
              >
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex-row content_nav_item" v-if="type_second == 'tiku'">
            <span class="flex-row-v-center">难度：</span>
            <div class="flex-1 flex-row" style="flex-flow: wrap">
              <div
                :class="{
                  content_nav_item_btn: true,
                  content_nav_item_btn_active: switch_topicDifficulty == index,
                  'flex-center': true,
                }"
                v-for="(item, index) in topicDifficultyList"
                :key="index"
                @click="switchTopicDifficulty(item, index)"
              >
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex-row content_nav_item" v-if="type_second == 'tiku'">
            <span>题型：</span>
            <div class="flex-1 flex-row" style="flex-flow: wrap">
              <div
                :class="{
                  content_nav_item_btn: true,
                  content_nav_item_btn_active: switch_tikuLabel == index,
                  'flex-center': true,
                }"
                v-for="(item, index) in tikuLabelList"
                :key="index"
                @click="switchTikuLabel(item, index)"
              >
                <span>
                  {{ item.n }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 content_box">
          <div class="content_list">
            <div class="course_box_head" v-if="!isBox">
              <div class="course_search flex-row-center">
                <el-input
                  placeholder="请输入关键词"
                  v-model="searchTxt"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="btnsearch"
                    style="border-radius: 50%"
                  ></el-button>
                </el-input>
              </div>
              <div class="course_creat_sort">
                <div>
                  <el-popover
                    placement="bottom"
                    trigger="click"
                    popper-class="area_popper_course"
                    v-model="popover_sort_show"
                  >
                    <div
                      slot="reference"
                      class="course_creat_sort_btn"
                      style="cursor: pointer"
                    >
                      {{ sort_time }}-{{ sort_type }}
                      <i
                        :class="
                          popover_sort_show ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
                        "
                      ></i>
                    </div>
                    <div class="course_creat_sort_options">
                      <div class="course_creat_sort_options_disable">查看范围</div>
                      <div
                        :class="{ color_active: sort_time == '全部' }"
                        @click="change_sort_time('全部')"
                      >
                        全部
                      </div>
                      <div
                        :class="{ color_active: sort_time == '最近一周' }"
                        @click="change_sort_time('最近一周')"
                      >
                        最近一周
                      </div>
                      <div
                        :class="{ color_active: sort_time == '最近一月' }"
                        @click="change_sort_time('最近一月')"
                      >
                        最近一月
                      </div>
                      <div
                        :class="{ color_active: sort_time == '最近一年' }"
                        @click="change_sort_time('最近一年')"
                      >
                        最近一年
                      </div>
                      <div class="course_creat_sort_options_disable">筛选排序</div>
                      <div
                        :class="{ color_active: sort_type == '时间最新' }"
                        @click="change_sort_type('时间最新')"
                      >
                        时间最新
                      </div>
                      <div
                        :class="{ color_active: sort_type == '时间最早' }"
                        @click="change_sort_type('时间最早')"
                      >
                        时间最早
                      </div>
                      <div
                        :class="{ color_active: sort_type == '热度最高' }"
                        @click="change_sort_type('热度最高')"
                      >
                        热度最高
                      </div>
                    </div>
                  </el-popover>
                </div>
                <!-- <div
                  class="creat_course"
                  v-if="type_second == 'homework' && type_first == 'my'"
                  @click="goPage"
                >
                  创建作业
                </div> -->
                <div
                  class="creat_course"
                  v-if="type_second == 'tiku' && type_first == 'my'"
                  @click="goToPage"
                >
                  新编习题
                </div>
              </div>
            </div>
            <!-- 作业 -->
            <div class="content_listBox" v-if="switchTab_task == 0 && !isBox">
              <div
                class="content_listBox_item clearfix"
                v-for="(item, index) in list_resource"
                :key="index"
              >
                <div class="flex-row-v-center">
                  <div class="content_item_icon">
                    <img v-if="item.homework_label_id != 0" :src="item.src" alt="" />
                    <img v-else src="../../assets/images/course_2.0/default.png" alt="" />
                  </div>
                  <div class="content_item_info flex-col">
                    <p>{{ item.title }}</p>
                    <div class="flex-row">
                      <div>
                        <span
                          v-for="(data, key) in homeworkLabelList"
                          v-if="data.id == item.homework_label_id && data.id != ''"
                          :key="key"
                          class="mr23"
                          >{{ data.name != "全部" ? data.name : "" }}</span
                        >
                      </div>

                      <div class="mr23">
                        热度 <span>{{ item.heat }}</span>
                      </div>
                      <div class="mr23">
                        题量 <span>{{ item.tiku_num }}</span>
                      </div>
                      <div class="mr23">
                        {{ item.createtime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content_item_btnBox flex-row">
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="onSubmit3(item)"
                    v-if="type_first == 'my' && item.status == 1"
                  >
                    <img
                      title="分享到学科"
                      src="../../assets/images/course_2.0/submit.png"
                      alt=""
                    />
                    <span>分享到学科</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="onSubmit3(item)"
                    v-if="
                      type_first == 'share' &&
                      item.status == 2 &&
                      item.teacher_uuid == userInfo.uuid
                    "
                  >
                    <img
                      title="分享到学校"
                      src="../../assets/images/course_2.0/submit.png"
                      alt=""
                    />
                    <span>分享到学校</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="onSubmit3(item)"
                    v-if="
                      type_first == 'school' &&
                      item.status == 3 &&
                      item.teacher_uuid == userInfo.uuid
                    "
                  >
                    <img
                      title="分享到多校"
                      src="../../assets/images/course_2.0/submit.png"
                      alt=""
                    />
                    <span>分享到多校</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="download_homeworkDialog(item, item.id)"
                  >
                    <img
                      title="下载"
                      src="../../assets/images/course_2.0/下载.png"
                      alt=""
                    />
                    <span>下载</span>
                  </div>

                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="issue_homework(item, index)"
                    v-if="type_first == 'my'"
                  >
                    <img
                      title="发布"
                      src="../../assets/images/course_2.0/发送.png"
                      alt=""
                    />
                    <span>发布</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="upload_homework(item, index)"
                    v-if="type_first == 'my'"
                  >
                    <img
                      title="发布"
                      src="../../assets/images/course_2.0/上传.png"
                      alt=""
                    />
                    <span>上传</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="edit_cloudhomework(item, item.id, $event, '编辑')"
                    v-if="type_first == 'cloud' && userInfo.power == 5"
                  >
                    <img
                      title="编辑"
                      src="../../assets/images/course_2.0/edit.png"
                      alt=""
                    />
                    <span>编辑</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="edit_homework(item, item.id, $event, '编辑')"
                    v-if="type_first != 'cloud'"
                  >
                    <img
                      title="编辑"
                      src="../../assets/images/course_2.0/edit.png"
                      alt=""
                    />
                    <span>编辑</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="collection(item)"
                    v-if="type_first != 'my' && !item.collection_id"
                  >
                    <img
                      title="收藏"
                      src="../../assets/images/course_2.0/收藏.png"
                      alt=""
                    />
                    <span>收藏</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="cancel_collection(item)"
                    v-if="type_first != 'my' && item.collection_id"
                  >
                    <img
                      title="已收藏"
                      src="../../assets/images/course_2.0/isLike.png"
                      alt=""
                    />
                    <span class="color999">已收藏</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="cancel_homework(item)"
                    v-if="type_first != 'my' && item.teacher_uuid == userInfo.uuid"
                  >
                    <img
                      title="撤销"
                      src="../../assets/images/course_2.0/删除.png"
                      alt=""
                    />
                    <span>撤销</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="del_cloudHomework(item)"
                    v-if="type_first == 'cloud' && userInfo.power == 5"
                  >
                    <img
                      title="删除"
                      src="../../assets/images/course_2.0/删除.png"
                      alt=""
                    />
                    <span>删除</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="del_data(item)"
                    v-if="type_first == 'my'"
                  >
                    <img
                      title="删除"
                      src="../../assets/images/course_2.0/删除.png"
                      alt=""
                    />
                    <span>删除</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    @click="preview_data(item)"
                  >
                    <img
                      title="预览"
                      src="../../assets/images/course_2.0/look.png"
                      alt=""
                    />
                    <span>预览</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级类别 -->
            <div class="content_listBox" v-if="isBox">
              <div
                class="content_listBox_item clearfix"
                v-for="(item, index) in list_resource"
                :key="index"
                @click="getHomework(item)"
              >
                <div class="flex-row-v-center">
                  <div class="content_item_icon">
                    <img :src="item.image" alt="" />
                  </div>
                  <div class="content_item_info flex-col">
                    <p>{{ item.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 习题 -->
            <div class="content_listBox" v-if="type_second == 'tiku'">
              <div
                class="topic_list_item"
                v-for="(item, index) in list_resource"
                :key="index"
              >
                <div
                  class="topic_content_html"
                  style="overflow-x: auto"
                  v-html="item.content"
                ></div>
                <div class="flex-row-space-between" style="margin-bottom: 10px">
                  <div class="flex-row-v-center topic_txt">
                    <span>{{ change_topic_type(item.type_id) }}</span>
                    <span>{{ item.level }}星</span>
                    <span>使用:{{ item.heat }}次</span>
                  </div>
                  <div class="topic_Btn flex-row-v-center">
                    <div
                      class="content_item_btnBox_item flex-row-v-center"
                      @click="del_data(item)"
                      v-if="type_first == 'my'"
                    >
                      <img
                        title="删除"
                        src="../../assets/images/course_2.0/删除.png"
                        alt=""
                      />
                      <span>删除</span>
                    </div>
                    <div
                      class="flex-row-v-center"
                      v-if="!item.answer_show"
                      @click="item_answer_show(item)"
                    >
                      <img src="../../assets/images/course_2.0/isanalysis.png" alt="" />
                      解析
                    </div>
                    <div
                      class="flex-row-v-center"
                      v-if="item.answer_show"
                      @click="item_answer_show(item)"
                    >
                      <img src="../../assets/images/course_2.0/analysis.png" alt="" />
                      收起解析
                    </div>
                    <div
                      class="topic_btnItem"
                      v-if="srcUuidsList.indexOf(item.uuid) == -1"
                      @click="addTikuCart(item)"
                    >
                      加入组题篮
                    </div>
                    <div
                      class="topic_btnItem"
                      style="background: #999999"
                      v-else
                      @click="cancelJoin(item)"
                    >
                      已加入组题篮
                    </div>
                  </div>
                </div>
                <div class="topic_answer_analyzing" v-if="item.answer_show">
                  <div>[答案]</div>
                  <div v-if="!Array.isArray(item.answer)" v-html="item.answer"></div>
                  <div v-else>
                    <div
                      v-for="(data, key) in item.answer"
                      :key="key"
                      v-html="data"
                    ></div>
                  </div>
                  <div>[解析]</div>
                  <div v-html="item.analyzing"></div>
                </div>
              </div>
            </div>

            <div v-if="!list_resource.length" class="course_card_empty"></div>
          </div>
          <div style="text-align: right" v-if="total > 10">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="changePage"
              :page-size="10"
              :current-page="pageNum"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <!-- 上传 -->
        <!-- <div class="dataBagBox flex-col-v-center" @click="goToPage">
          <div class="flex-row">
            <div class="dataBag2 flex-col-center">
              <img src="../../assets/images/course_2.0/upload.png" alt="" />
              <div class="numClass2">上传</div>
            </div>
          </div>
        </div> -->
        <!-- 题库篮 -->
        <div class="testQuestions" v-if="type_second == 'tiku'">
          <div class="flex-row">
            <div class="testQuestionsBox flex-col-v-center" @click.stop="enter2">
              <div
                class="testBtn flex-center"
                @click.stop="isShowTestList = !isShowTestList"
              >
                作业篮
              </div>
              <img src="../../assets/images/course_2.0/carticon.png" alt="" />
              <span class="tikuName" :title="tikuCartGroupName">{{
                tikuCartGroupName
              }}</span>
              <div class="numClass">{{ tikuCartListNum }}</div>
            </div>
            <div :class="{ testList: true, isShowTestList: isShowTestList }">
              <div
                :class="{
                  testListItem: true,
                  'flex-center': true,
                  testListItemActive: tikuCartGroupId == item.group_id,
                }"
                :title="item.name"
                v-for="(item, index) in tikuCartGroupList"
                :key="index"
                @click.stop="switchTestList(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <!-- 习题篮列表 -->
        <div class="tipTiku flex-col" v-show="isShowTikuTip" @mouseleave="leave2">
          <div class="flex-row-space-between" style="margin-bottom: 14px">
            <div class="tipHead">
              <span>已选择习题：</span>
              <span style="color: #ff9b36">{{ tikuCartListNum }}习题</span>
            </div>
            <div style="cursor: pointer" @click="batchDelTiku">
              <img
                style="width: 20px; height: 20px"
                src="../../assets/images/course_2.0/allDelete.png"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="tikuCartListNum > 0"
            class="flex-1"
            style="overflow-y: auto; overflow-x: hidden; margin-bottom: 10px"
          >
            <div
              class="tikuListItem flex-row-space-between"
              v-for="(item, index) in tikuCartList"
              :key="index"
            >
              <div class="tikuTypeName">
                {{ change_topic_type(item.type_id) }}
              </div>
              <div>{{ item.list.length }}</div>
              <div>
                <div style="cursor: pointer" @click="delCourseTiku(item.type_id)">
                  <img
                    style="width: 16px; height: 16px"
                    src="../../assets/images/course_2.0/delete.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="flex-1">
            <el-empty :image-size="50" style="padding: 20px 0"></el-empty>
          </div>
          <div @click="goPage('0')" class="tipBtn flex-center">组卷预览</div>
          <div class="trangle"></div>
        </div>
      </div>
    </div>
    <!-- 已发作业 -->
    <div class="wrapper flex-row-center" v-show="!isShowHomeWork">
      <div class="homeWorkBox flex-col">
        <div class="homeWorkHead flex-row-space-between">
          <div class="course_search">
            <el-input
              placeholder="请输入关键词"
              v-model="searchTxt_homewrok"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="get_my_unwork_List"
                style="border-radius: 50%"
              ></el-button>
            </el-input>
          </div>
          <div class="course_creat_sort">
            <div style="margin-right: 10px">
              <el-select
                v-model="selectClass_id"
                @change="get_my_unwork_List"
                clearable
                filterable
                placeholder="请选择班级"
              >
                <el-option
                  v-for="item in allClassList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course"
                v-model="popover_sort_show_homework"
              >
                <div
                  slot="reference"
                  class="course_creat_sort_btn"
                  style="cursor: pointer"
                >
                  {{ sort_time_homework }}-{{ sort_type_homework }}
                  <i
                    :class="
                      popover_sort_show_homework
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "
                  ></i>
                </div>
                <div class="course_creat_sort_options">
                  <div class="course_creat_sort_options_disable">查看范围</div>
                  <div
                    :class="{ color_active: sort_time_homework == '全部' }"
                    @click="change_sort_time_homework('全部')"
                  >
                    全部
                  </div>
                  <div
                    :class="{ color_active: sort_time_homework == '最近一周' }"
                    @click="change_sort_time_homework('最近一周')"
                  >
                    最近一周
                  </div>
                  <div
                    :class="{ color_active: sort_time_homework == '最近一月' }"
                    @click="change_sort_time_homework('最近一月')"
                  >
                    最近一月
                  </div>
                  <div
                    :class="{ color_active: sort_time_homework == '最近一年' }"
                    @click="change_sort_time_homework('最近一年')"
                  >
                    最近一年
                  </div>
                  <div class="course_creat_sort_options_disable">筛选排序</div>
                  <div
                    :class="{ color_active: sort_type_homework == '时间最新' }"
                    @click="change_sort_type_homework('时间最新')"
                  >
                    时间最新
                  </div>
                  <div
                    :class="{ color_active: sort_type_homework == '时间最早' }"
                    @click="change_sort_type_homework('时间最早')"
                  >
                    时间最早
                  </div>
                  <div
                    :class="{ color_active: sort_type_homework == '热度最高' }"
                    @click="change_sort_type_homework('热度最高')"
                  >
                    热度最高
                  </div>
                </div>
              </el-popover>
            </div>
            <!-- <div class="creat_course" @click="goPage">创建作业/组卷</div> -->
          </div>
        </div>
        <div class="homeWorkContent flex-1" style="overflow-y: auto">
          <div
            class="homeWorkItem flex-col"
            v-for="(item, index) in homework_savelist"
            :key="index"
          >
            <div class="homeWorkItemContent flex-row-space-between">
              <div class="flex-row-center">
                <div class="homeWorkItemContentImg">
                  <img
                    src="../../assets/images/course_2.0/考试1.png"
                    v-if="item.structure_type == 4"
                    alt=""
                  />
                  <img v-else src="../../assets/images/course_2.0/default.png" alt="" />
                </div>
                <div>
                  <div class="flex-row-v-center marginBottm25">
                    <div class="homeWorkItemContentTitle">
                      {{ item.homework_name }}
                    </div>
                    <div class="homeWorkItemContentStatus flex-center">进行中</div>
                  </div>
                  <div class="flex-row-v-center">
                    <div class="homeWorkItemContentTxt">班级:{{ item.class_name }}</div>
                    <div class="homeWorkItemContentTxt">
                      发布形式:<span v-if="item.assigned == 0">老师批改</span>
                      <span v-if="item.assigned == 1">学生互批</span>
                      <span v-if="item.assigned == 2">学生自批</span>
                      <span v-if="item.assigned == 5">教师批改（打分卡）</span>
                      <span v-if="item.assigned == 3">学生自批（打分卡）</span>
                      <span v-if="item.assigned == 4">学生互批（打分卡）</span>
                    </div>
                    <div class="homeWorkItemContentTxt">
                      发布时间:{{ TimestampToTime(item.createtime) }}|截止时间:{{
                        TimestampToTime(item.endtime)
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="flex-row-h-center"
                v-if="
                  !(item.structure_type == 6 && !item.page_message) &&
                  isShowHomeWorkIndex != 3
                "
              >
                <div
                  class="homeWorkItemBtn flex-center"
                  v-if="item.assigned == 0"
                  @click="to_correct(item)"
                  style="margin-right: 10px"
                >
                  批改
                </div>
                <div
                  class="homeWorkItemBtn flex-center"
                  v-if="item.assigned == 5"
                  @click="to_correct(item)"
                  style="margin-right: 10px"
                >
                  打分
                </div>
                <div
                  class="homeWorkItemBtn flex-center"
                  @click="to_correct(item)"
                  style="margin-right: 10px"
                  v-if="item.assigned == 1 || item.assigned == 2"
                >
                  抽批
                </div>
                <div
                  class="homeWorkItemBtn flex-center"
                  @click="to_correct(item)"
                  style="margin-right: 10px"
                  v-if="item.assigned == 3 || item.assigned == 4"
                >
                  抽批
                </div>
                <div class="homeWorkItemBtn3 flex-center" @click="remove_homework(item)">
                  删除
                </div>
              </div>
              <div class="flex-row-h-center" v-if="isShowHomeWorkIndex == 3">
                <div
                  class="homeWorkItemBtn flex-center"
                  v-if="item.structure_type == 4"
                  @click="handledowload(item)"
                  style="margin-right: 10px"
                >
                  导出成绩
                </div>
                <div
                  class="homeWorkItemBtn2 flex-center"
                  @click="workpaper(item)"
                  style="margin-right: 10px"
                >
                  分析讲评
                </div>
              </div>
            </div>
            <div
              class="homeWorkItemFooter flex-row-space-between"
              v-if="isShowHomeWorkIndex"
            >
              <div class="flex-row homeWorkItemFooterTxt">
                <div class="flex-row-center marginRight36">
                  <span>已提交:</span>
                  <el-progress
                    status="warning"
                    style="width: 150px; margin: 0 8px"
                    :show-text="false"
                    :percentage="item.submitPercentage"
                    :stroke-width="7"
                  ></el-progress>
                  <span style="color: #ff9b36">{{ item.submitNum }}</span
                  >/
                  <span>{{ item.student_num }}</span>
                </div>
                <div class="flex-row-center">
                  <span>已批改:</span>
                  <el-progress
                    style="width: 150px; margin: 0 8px"
                    :show-text="false"
                    :percentage="item.correctionPercentage"
                    :stroke-width="7"
                  ></el-progress>
                  <span style="color: #69b4ff">{{ item.correctionNum }}</span
                  >/
                  <span>{{ item.student_num }}</span>
                </div>
              </div>
              <div class="flex-row">
                <!-- <div class="homeWorkItemFooterBtn">结束批改</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="homeWorkFooter">
          <div style="text-align: right" v-if="homework_total > 10">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="changePage_homework"
              :page-size="11"
              :current-page="homework_page"
              :total="homework_total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 预览作业 -->
    <div class="wrapper" v-show="isPreviewShow && isShowHomeWork">
      <div class="previewListBox">
        <div class="previewListBoxHead flex-row-space-between">
          <div class="backIcon" @click="isPreviewShow = false">
            <img src="../../assets/images/course_2.0/返回.png" alt="" />
          </div>
          <div>{{ taskInfoName }}</div>
          <div class="previewBtn" @click="batchJoinTask">全部加入组卷篮</div>
        </div>
        <div>
          <div
            class="topic_list_item2"
            v-for="(item, index) in taskInfoList"
            :key="index"
          >
            <div
              class="topic_content_html"
              style="overflow-x: auto"
              v-html="item.content"
            ></div>
            <div class="flex-row-space-between" style="margin-bottom: 10px">
              <div class="flex-row-v-center topic_txt">
                <span>{{ change_topic_type(item.type_id) }}</span>
                <span>{{ item.level }}星</span>
              </div>
              <div class="topic_Btn flex-row-v-center">
                <div
                  class="flex-row-v-center"
                  v-if="!item.answer_show"
                  @click="item_answer_show(item)"
                >
                  <img src="../../assets/images/course_2.0/isanalysis.png" alt="" />
                  解析
                </div>
                <div
                  class="flex-row-v-center"
                  v-if="item.answer_show"
                  @click="item_answer_show(item)"
                  style="color: #ff9b36"
                >
                  <img src="../../assets/images/course_2.0/analysis.png" alt="" />
                  收起解析
                </div>
                <div
                  class="topic_btnItem"
                  v-if="srcUuidsList.indexOf(item.uuid) == -1"
                  @click="addTikuCart(item)"
                >
                  加入组题篮
                </div>
                <div
                  class="topic_btnItem"
                  style="background: #999999"
                  @click="cancelJoin(item)"
                  v-else
                >
                  已加入组题篮
                </div>
              </div>
            </div>
            <div class="topic_answer_analyzing2" v-if="item.answer_show">
              <div>[答案]</div>
              <div v-if="!Array.isArray(item.answer)" v-html="item.answer"></div>
              <div v-else>
                <div v-for="(data, key) in item.answer" :key="key" v-html="data"></div>
              </div>
              <div>[解析]</div>
              <div v-html="item.analyzing"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 上传 -->
      <div class="dataBagBox2 flex-col-v-center" @click="goToPage">
        <div class="flex-row">
          <div class="dataBag2 flex-col-center">
            <img src="../../assets/images/course_2.0/upload.png" alt="" />
            <div class="numClass2">上传</div>
          </div>
        </div>
      </div>
      <!-- 题库篮 -->
      <div class="testQuestions2">
        <div class="flex-row">
          <div class="testQuestionsBox flex-col-v-center" @click.stop="enter2">
            <div
              class="testBtn flex-center"
              @click.stop="isShowTestList = !isShowTestList"
            >
              作业篮
            </div>
            <img src="../../assets/images/course_2.0/carticon.png" alt="" />
            <span class="tikuName" :title="tikuCartGroupName">{{
              tikuCartGroupName
            }}</span>
            <div class="numClass">{{ tikuCartListNum }}</div>
          </div>
          <div :class="{ testList: true, isShowTestList: isShowTestList }">
            <div
              :class="{
                testListItem: true,
                'flex-center': true,
                testListItemActive: tikuCartGroupId == item.group_id,
              }"
              :title="item.name"
              v-for="(item, index) in tikuCartGroupList"
              :key="index"
              @click.stop="switchTestList(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 习题篮列表 -->
      <div class="tipTiku2 flex-col" v-show="isShowTikuTip" @mouseleave="leave2">
        <div class="flex-row-space-between" style="margin-bottom: 14px">
          <div class="tipHead">
            <span>已选择习题：</span>
            <span style="color: #ff9b36">{{ tikuCartListNum }}习题</span>
          </div>
          <div style="cursor: pointer" @click="batchDelTiku">
            <img
              style="width: 20px; height: 20px"
              src="../../assets/images/course_2.0/allDelete.png"
              alt=""
            />
          </div>
        </div>
        <div
          v-if="tikuCartListNum > 0"
          class="flex-1"
          style="overflow-y: auto; overflow-x: hidden; margin-bottom: 10px"
        >
          <div
            class="tikuListItem flex-row-space-between"
            v-for="(item, index) in tikuCartList"
            :key="index"
          >
            <div class="tikuTypeName">
              {{ change_topic_type(item.type_id) }}
            </div>
            <div>{{ item.list.length }}</div>
            <div>
              <div style="cursor: pointer" @click="delCourseTiku(item.type_id)">
                <img
                  style="width: 16px; height: 16px"
                  src="../../assets/images/course_2.0/delete.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="flex-1">
          <el-empty :image-size="50" style="padding: 20px 0"></el-empty>
        </div>
        <div @click="goPage('0')" class="tipBtn flex-center">组卷预览</div>
        <div class="trangle"></div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import ifram from "../../components/ifarm/ifarm";
import bus from "../../plugins/Bus";
import preventReClick from "../../config/preventReclick"; //防多次点击，重复提交
import { TimestampToTime } from "../../config/common";
import { changeData_long, getNodeCode, getNodeCode_topic } from "../../assets/js/common";
import { TimestampToTime_weekday, TimestampToTime_ss } from "../../config/common";
import homeTimetable from "../../components/home/home_timetable.vue";
import previewData from "../../components/common_module/preview_data.vue";

export default {
  components: { homeTimetable, previewData, ifram, draggable, preventReClick },
  name: "resource",
  data() {
    return {
      homeworkDialog: false,
      homework_detail: "",
      selectClass_id: "",
      allClassList: [],
      isShowHomeWorkIndex: 1,
      homework_savelist: [],
      homework_total: "",
      homework_page: 1,
      searchTxt_homewrok: "",
      isShowHomeWork: true,
      list_resource: [],
      isBox: false,
      isPreviewShow2: false,
      tree_num: [],
      cartListByOtherUuid: [],
      activeItem: "",
      switchData_type: 0,
      isIndeterminateClass: true,
      isIndeterminateGroup: true,
      checkAllClass: false,
      checkAllGroup: false,
      send_item: "",
      class_list_choosed: [],
      group_list_choosed: [],
      choose_class_dia: false,
      work_item: "",
      chooseday_index: 0,
      dialogVisible_classtable: false,
      physical_classes_id: "",
      physical_classes_name: "",
      visible: false,
      form: {
        class_ids: [],
        class_id: [],
        grouping_id: [],
        nowChangeName: "",
        grouping_Isblock: [],
        class_Isblock: [],
      },
      slect_class_arr: [],
      slect_grouping_arr: [],

      can_add: true,
      userInfo: "",
      show_progress: false,
      status: 2,
      ispercentage: 0,
      add_material_list: [],
      options_add_material_attrs: {},
      add_material_name: "新建资料",
      dialogVisible_add_material: false,
      change_attr: true,
      status_resource: false,
      edit_material_item_type: "add",
      srcUuidsList: [],
      taskInfoName: "",
      taskInfoList: [],
      isPreviewShow: false,
      isShowTestList: false,
      tikuCartList: [],
      isShowTikuTip: false,
      tikuCartListNum: 0,
      tikuCartGroupList: [],
      tikuCartGroupName: "",
      tikuCartGroupId: "",
      checkedCartList: [],
      isShowTip: false,
      cartListByOtherNum: 0,
      answer_show: false,
      tab_active_tree_head: 0,
      cartListByOther: [], //资料袋
      newSubject_nodeData: [],
      correct_type: "5",
      correct_endtime: "",
      show_answer: "0",
      limit_answer: true,
      limit_answer_time: 40,
      correct_endtime: "",
      datetime: "",
      homework_require: "",
      structure_type: "0",
      useage_type: "1",
      classIds: "",
      groupIds: "",
      groupingList: [],
      classList: [],
      homework_list: "",
      saveHomeWorkDialogVisible: false,
      type_second: "homework",
      tab_active: 0, //来源
      type_first: "my", //来源
      switchTab_task: 0, //切换作业还是习题
      homeworkLabelList: [], //习题类别
      homework_label_id: "",
      searchTxt: "", //模糊查询字段
      switchTab_taskLabel: 0,
      topicDifficulty: "", //题型难度
      switch_topicDifficulty: 0,
      tikuLabelList: [],
      switch_tikuLabel: 0,
      tikuLabelId: "",
      tree_code_node: "",
      list_resource: [],
      total: 0,
      popover_sort_show: false,
      popover_sort_show_homework: false,
      sort_time_homework: "全部",
      sort_type_homework: "时间最新",
      order_homework: "descending",
      sort_homework: "createtime",
      startTime_sort_homework: "",
      endTime_sort_homework: "",

      sort_time: "全部",
      sort_type: "时间最新",
      order: "descending",
      sort: "createtime",

      startTime_sort: "",
      endTime_sort: "",
      pageNum: 1,
      pageSize: 10,

      prew_type: "",
      prew_content: "",
      dialogVisible_previewData: false,
      options_add_material: {
        target: "",
        testChunks: false,
        allowDuplicateUploads: true,
        attrs: {
          accept: "*",
        },

        chunkSize: "1024000",
      },
      showNode: [],
      showNode_node: [],
      class_list: [],
      tab_list_resource: [
        { name: "我的", id: 4 },
        { name: "学科", id: 3 },
        { name: "学校", id: 2 },
        { name: "多校", id: 1 },
      ],
      switchTabList: [
        { name: "挑选作业", id: 1 },
        { name: "挑选习题", id: 2 },
      ],
      SectionData: [],
      SectionProps: {
        children: "children",
        label: "name",
      },
      newSubject_nodeProps: {
        children: "children",
        label: "name",
      },
      topicDifficultyList: [
        { name: "全部", id: "" },
        { name: "一星", id: 1 },
        { name: "二星", id: 2 },
        { name: "三星", id: 3 },
        { name: "四星", id: 4 },
        { name: "五星", id: 5 },
      ],
      question_nd: [
        { name: "全部" },
        { name: "较易" },
        { name: "中档" },
        { name: "较难" },
        { name: "难" },
      ],
      question_ly: [
        { name: "中考真题" },
        { name: "自主招生" },
        { name: "中考模拟" },
        { name: "中考复习" },
        { name: "期中试题" },
        { name: "期中试题" },
        { name: "月考试题" },
        { name: "单元考卷" },
        { name: "练习册" },
        { name: "竞赛试题" },
        { name: "假期作业" },
      ],
      sorts: [
        { name: "时间", active: false },
        { name: "热度", active: true },
      ],
      question_type: [],
      book: [],
      code: [],
      new_tree_code_add: "", //章节编码
      chapter_name: "",
      tree_code: "",
      arr_to_classtable: [{ class_name: "" }],
      creat_class_list: [
        {
          class_id: { class_id: "", class_name: "" },
          course_type: "1",
          endtime: new Date(Date.parse(new Date()) + 1000 * 24 * 60 * 60),
        },
      ],
      courseCartGroupList: [],
      courseCartGroupName: "",
      courseCartGroupId: "",
      isShowCourseList: false,
    };
  },
  watch: {
    visible: function (newVal, oldVal) {
      this.arr_to_classtable = [];
      this.arr_to_classtable.push({ class_name: "" });
      this.creat_class_list = [
        {
          class_id: { class_id: "", class_name: "" },
          course_type: "1",
          endtime: new Date(Date.parse(new Date()) + 1000 * 24 * 60 * 60),
        },
      ];
    },

    status_resource(newVal, oldVal) {
      this.topic_status = newVal ? 1 : 2;
      this.status = newVal ? 1 : 2;
    },
    structure_type(newVal, oldVal) {
      this.classIds = "";
      if (newVal == 4) {
        this.axios
          .post("/school/classes/physicalClassesList?group_by_grade=1")
          .then((res) => {
            if (res.data.code == 1) {
              var arr = res.data.data.data;
              this.classList = arr;
              console.log(arr);
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
                duration: 1500,
                showClose: true,
              });
            }
          });
      } else {
        this.get_class_list(); //获取班级
      }
    },
  },
  provide() {
    return {
      //子组件调用的名字：对应的方法（当前页面，祖父级元素的方法）
      from_classtable: this.from_classtable,
    };
  },
  mounted() {
    if (this.$route.query.isadd) {
      if (this.$route.query.isadd == 1) {
        this.type_second = "tiku";
        this.tab_active = 0;
        this.type_first = "my";
        this.switchTab_task = 1;
      } else {
        this.type_second = "homework";
        this.tab_active = 0;
        this.type_first = "my";
        this.switchTab_task = 0;
      }
    }
    if (this.$route.query.active == 1) {
      this.isShowHomeWork = false;
      this.isShowHomeWorkIndex = 2;
    }
    if (this.$route.query.isShowHomeWorkIndex == 3) {
      this.isShowHomeWork = false;
      this.isShowHomeWorkIndex = 3;
    }
    this.get_class_list(); //获取班级
    this.get_type();
    this.get_data_all_type();
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getSubject(sessionStorage.subject_code);
    this.getNode(sessionStorage.subject_code);
    this.getHomeworkLabel();
    //this.get_sourceBag();
    this.gettikuLabel();
    this.getTikuCartGroupList();
    this.get_tree_num();
    //获取已发作业
    this.get_my_unwork_List();
    //document.body.addEventListener("click", this.bodyClick, true);
  },
  beforeDestroy() {
    //document.body.removeEventListener("click", this.bodyClick);
  },
  methods: {
    openPage(type) {
      if (type == 1) {
        window.open("https://www.zxxk.com/", "_blank");
      } else {
        window.open("https://www.jyeoo.com/", "_blank");
      }
    },
    //下载成绩接口
    handledowload(data) {
      this.$message({
        message: "正在下载",
        type: "success",
        duration: 1500,
        showClose: true,
      });

      let formData = new FormData();
      formData.append("physical_class_id", data.physical_class_id || "");
      formData.append("subject_code", data.subject_code);
      formData.append("homework_name", data.homework_name);
      formData.append("createtime", data.createtime);

      this.axios({
        method: "post",
        url: "/school/exam_tongji/downloadExcel",
        data: formData,
        responseType: "arraybuffer",
      }).then((res) => {
        // 生成 Blob 对象，设置 type 等信息
        const e = new Blob([res.data], {
          type: "application/octet-stream",
          "Content-Disposition": "attachment",
        });
        // 将 Blob 对象转为 url
        const link = window.URL.createObjectURL(e);
        this.handleFileDownload(link, `${data.homework_name}-考试成绩.xlsx`);
      });
    },
    handleFileDownload(url, filename) {
      // 创建 a 标签
      let a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
    },
    goToResourceSend() {
      this.$router.push("/resource_send?type=1");
    },

    download_homeworkDialog(item) {
      this.homeworkDialog = true;
      this.homework_detail = item;
    },
    workpaper(item) {
      // sessionStorage.setItem('isShowHomeWorkIndex',3)
      this.axios
        .post("/school/Homework_Usages/jiangping", { id: item.id })
        .then((res) => {
          if (res.data.code == 1) {
            this.$router.push(
              "/homework/homework_report?class_id=" +
                item.class_id +
                "&batch_id=" +
                item.id +
                "&homework_title=" +
                item.title +
                "&homework_src_uuid=" +
                item.homework_src_uuid +
                "&assigned=" +
                item.assigned
            );
          }
        });
      console.log(item);
    },
    to_correct(item) {
      if (item.assigned == 5 || item.assigned == 3 || item.assigned == 4) {
        this.$router.push(
          "/homework/homework_grade?class_id=" +
            item.class_id +
            "&batch_id=" +
            item.id +
            "&homework_title=" +
            item.title +
            "&structure_type=" +
            item.structure_type +
            "&assigned=" +
            item.assigned
        );
      } else {
        this.$router.push(
          "/homework/homework_correct?class_id=" +
            item.class_id +
            "&batch_id=" +
            item.id +
            "&homework_title=" +
            item.title +
            "&structure_type=" +
            item.structure_type
        );
      }
    },
    TimestampToTime(t) {
      return TimestampToTime(t);
    },
    //分页 换页
    changePage_homework(pageNum) {
      this.homework_page = pageNum;
      this.get_my_unwork_List();
    },
    remove_homework(row) {
      this.$confirm("此操作将删除发送" + row.title + "作业, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var formData = new FormData();
          formData.append("id", row.id);
          formData.append("course_batch_id", row.course_batch_id);
          this.axios
            .post("/school/homework_Usages/delHomeworkUsages", formData)
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1500,
                  showClose: true,
                });
                this.get_my_unwork_List();
                // this.getQs_total--;
                // if (this.getQs_total <= (this.getQs_pageNum - 1) * 10) {
                //   this.getQs_pageNum -= 1;
                // }
                // if (this.getQs_pageNum <= 1) {
                //   this.getQs_pageNum = 1;
                // }
                // this.$emit("page_s", this.getQs_total, this.getQs_pageNum);
                // this.visible = false;
                // this.$emit("get_my_unwork_List", this.order, this.sort);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  duration: 500,
                  showClose: true,
                });
              }
            });
        })
        .catch(() => {});
      //this.cancelPopover();
    },
    get_my_unwork_List() {
      var formData = new FormData();
      formData.append("current_page", this.homework_page);
      formData.append("order", this.order_homework);
      formData.append("sort", this.sort_homework);
      formData.append("name", this.searchTxt_homewrok);
      formData.append("start_time", this.startTime_sort_homework);
      formData.append("end_time", this.endTime_sort_homework);
      formData.append("page_size", 11);
      formData.append("class_id", this.selectClass_id);
      this.axios
        .post("/school/Homework_Usages/homeworkUsagesList", formData)
        .then((res) => {
          if (res.data.code == 1) {
            this.homework_savelist = res.data.data.data;
            this.homework_total = res.data.data.count;
            for (let i in this.homework_savelist) {
              this.homework_savelist[i].submitNum = Number(
                this.homework_savelist[i].class_submit_json.split("/")[0]
              );
              this.homework_savelist[i].correctionNum = Number(
                this.homework_savelist[i].class_correction_json.split("/")[0]
              );
              this.homework_savelist[i].submitPercentage =
                (this.homework_savelist[i].submitNum /
                  this.homework_savelist[i].student_num) *
                100;
              this.homework_savelist[i].correctionPercentage =
                (this.homework_savelist[i].correctionNum /
                  this.homework_savelist[i].student_num) *
                100;
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 500,
              showClose: true,
            });
          }
        });
    },

    //查询已发作业
    btnsearch_homewrok() {},
    //点击切换
    clickNav(item) {
      let that = this;
      if (item == 1) {
        let sectionData = localStorage.getItem("sectionData")
          ? JSON.parse(localStorage.getItem("sectionData"))
          : "";
        console.log(sectionData);
        if (sectionData) {
          this.getSectionData(sectionData);
          this.$nextTick(() => {
            that.$refs.treeBox.setCurrentKey(sectionData.guid);
          });
        }
        this.isShowHomeWorkIndex = item;
        this.isShowHomeWork = true;
      } else {
        this.isShowHomeWorkIndex = item;
        this.isShowHomeWork = false;
      }
    },

    bodyClick() {
      this.isShowTikuTip = false;
      this.isShowTip = false;
      this.isShowCourseList = false;
      this.isShowTestList = false;
    },
    del_cloudHomework(item) {
      this.$confirm("此操作将删除作业, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("id", item.id);
          formData.append("is_cloud", 1);
          this.axios
            .post("https://www.gaokaowin.com/proxy2/cloud/homework/delHomework", formData)
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                  duration: 500,
                  showClose: true,
                });
                this.get_sourceBag();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  duration: 500,
                  showClose: true,
                });
              }
            });
        })
        .catch(() => {});
    },
    dataFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
    // 请求树 数量
    get_tree_num() {
      let url;
      let formData = new FormData();
      // console.log(this.type_first)
      if (this.type_first == "my") {
        url = "/school/bag/mySourceStatistics";
      } else if (this.type_first == "share") {
        url = "/school/bag/schoolSourceStatistics";
        formData.append("status", 2);
      } else if (this.type_first == "school") {
        url = "/school/bag/schoolSourceStatistics";
        formData.append("status", 3);
      } else {
        url = "/teacher/subject/cloudsourcestatistics";
      }
      if (this.type_second == "homework") {
        formData.append("type", 4);
      } else if (this.type_second == "tiku") {
        formData.append("type", 10);
      }
      formData.append("textbook_guid", sessionStorage.text_book_guid);
      this.axios.post(url, formData).then((res) => {
        // console.log(res.data.data.total)
        if (res.data.code == 1) {
          // this.$message({
          //   type:'success',
          //   message:res.data.msg,
          //   duration:1500,showClose: true
          // })t
          // this.tree_num=[]
          this.tree_num = res.data.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    edit_cloudhomework(item) {
      let textbook_guid = sessionStorage.getItem("text_book_guid");
      let group_id = this.tikuCartGroupList[this.tikuCartGroupList.length - 1].group_id;
      let arr = group_id.split("_");
      window.open(
        `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${arr[0]}_${
          Number(arr[1]) + 1
        }&chapter_code=${this.new_tree_code_add}&chapter_name=${
          this.chapter_name
        }&textbook_guid=${textbook_guid}&homework_uuid=${
          item.homework_uuid || item.uuid
        }&heat=${item.heat}&homework_id=${item.id}&is_cloud=1&from=hxb_homework`,
        "_self"
      );
    },
    async edit_homework(item) {
      let textbook_guid = sessionStorage.getItem("text_book_guid");
      this.axios.get("/school/cart/tikuCartGroupList").then((res) => {
        if (res.data.code == 1) {
          this.tikuCartGroupList = res.data.data.data;
          this.tikuCartGroupName = this.tikuCartGroupList[0].name;
          this.tikuCartGroupId = this.tikuCartGroupList[0].group_id;
          for (let i in this.tikuCartGroupList) {
            if (this.tikuCartGroupList[i].checked == 1) {
              this.tikuCartGroupName = this.tikuCartGroupList[i].name;
              this.tikuCartGroupId = this.tikuCartGroupList[i].group_id;
            }
          }
          let group_id = this.tikuCartGroupList[this.tikuCartGroupList.length - 1]
            .group_id;
          let arr = group_id.split("_");
          window.open(
            `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${
              arr[0]
            }_${Number(arr[1]) + 1}&chapter_code=${this.new_tree_code_add}&chapter_name=${
              this.chapter_name
            }&textbook_guid=${textbook_guid}&homework_uuid=${
              item.homework_uuid || item.uuid
            }&heat=${item.heat}&homework_id=${item.homework_id}&from=hxb_homework`,
            "_self"
          );
        }
      });
    },
    cancelJoin(item) {
      let params = {
        tiku_uuid: item.uuid || item.tiku_uuid,
        group_id: this.tikuCartGroupId,
      };
      this.axios.post("/school/cart/delTikuCart", params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "取消成功",
          });
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },
    //跳转到上传习题
    goToPage() {
      let textbook_guid = sessionStorage.getItem("text_book_guid");
      let textbook_name = this.userInfo.textbook_name;
      window.open(
        `https://www.gaokaowin.com/huixuebao/exam/#/addQuestionhxb?chapter_code=${this.new_tree_code_add}&textbook_guid=${textbook_guid}&textbook_name=${textbook_name}&isBlank=1&from=hxb_homework`,
        "_self"
      );
    },
    onSubmit(item) {
      let params = {
        course_id: item.course_id,
        approval_status: 30,
      };
      this.axios.post("/school/course/changeApprovalStatus", params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "提交成功",
            duration: 1500,
            showClose: true,
          });
          this.get_sourceBag();
        }
      });
    },
    //取消收藏
    cancel_collection(item) {
      let url = "";
      let params = {};
      if (this.type_second == "homework") {
        url = "/school/Collection_homework/delCollection";
        params.homework_uuid = item.uuid;
      }
      if (this.type_second == "tiku") {
        url = "/school/Collection_tiku/delCollection";
        params.tiku_uuid = item.uuid || item.tiku_uuid;
      }
      this.axios.post(url, params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 1500,
            showClose: true,
          });
          this.get_sourceBag();
        }
      });
    },
    //跳转已发送
    to_send_page() {
      this.$router.push("/resource_send");
    },
    uncollect_school(id) {
      this.$confirm("此操作将删除学校资料, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var formData = new FormData();
          formData.append("id", id);
          formData.append("heat", 0);
          formData.append("status", 2);

          this.axios.post("/school/material/editMaterial", formData).then((res) => {
            // console.log(res);
            if (res.data.code == 1) {
              // this.Iscollect = true;
              this.$message({
                message: res.data.msg,
                type: "success",
                duration: 1500,
                showClose: true,
              });
              res.data.Iscollect = true;
              this.getQs_total--;
              if (this.getQs_total <= (this.getQs_pageNum - 1) * 10) {
                this.getQs_pageNum -= 1;
              }
              if (this.getQs_pageNum <= 1) {
                this.getQs_pageNum = 1;
              }
              // this.$emit("page_s", this.getQs_total, this.getQs_pageNum);
              // this.$emit("get_my_data_list", this.order, this.sort);
              this.get_sourceBag();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                duration: 500,
                showClose: true,
              });
            }
          });
        })
        .catch(() => {});
    },
    //切换资源包
    switchDataType(item, index) {
      this.switchData_type = index;
      this.type_second = item.value;
      this.get_sourceBag();
    },
    confirm_send_homework() {
      let arr = [];
      arr = arr.concat(this.class_list_choosed);
      arr = arr.concat(this.group_list_choosed);
      let item = this.send_item;
      let str_arr = [];
      for (let i in arr) {
        str_arr.push(arr[i].id);
      }
      if (this.type_second == "guidance") {
        let formdata = new FormData();
        formdata.append("subject_code", sessionStorage.subject_code);
        formdata.append("chapter_code", item.chapter_code);
        formdata.append("guidance_src_uuid", item.guidance_uuid);
        formdata.append("guidance_name", item.name);
        formdata.append("class_ids", str_arr.join(","));
        this.axios
          .post("/school/guidance_Usages/addGuidanceUsages", formdata)
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: res.data.msg,
                duration: 1500,
                showClose: true,
              });
              this.choose_class_dia = false;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
                duration: 1500,
                showClose: true,
              });
            }
          });
      } else {
        let formdata = new FormData();
        formdata.append("subject_code", sessionStorage.subject_code);
        formdata.append("chapter_code", item.chapter_code);
        formdata.append("material_src_uuid", item.material_uuid);
        formdata.append("material_name", item.name);
        formdata.append("class_ids", str_arr.join(","));
        this.axios
          .post("/school/Material_Usages/addMaterialUsages", formdata)
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: res.data.msg,
                duration: 1500,
                showClose: true,
              });
              this.choose_class_dia = false;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
                duration: 1500,
                showClose: true,
              });
            }
          });
      }
    },
    handleCheckAllChangeClass(val) {
      let arr = [];
      for (let i in this.class_list) {
        if (this.class_list[i].type == 1) {
          arr.push(this.class_list[i]);
        }
      }
      this.class_list_choosed = val ? arr : [];
      this.isIndeterminateClass = false;
    },
    handleCheckedCitiesChangeClass(value) {
      let arr = [];
      for (let i in this.class_list) {
        if (this.class_list[i].type == 1) {
          arr.push(this.class_list[i]);
        }
      }
      let checkedCount = value.length;
      this.checkAllClass = checkedCount === arr.length;
      this.isIndeterminateClass = checkedCount > 0 && checkedCount < arr.length;
    },
    handleCheckAllChangeGroup(val) {
      let arr = [];
      for (let i in this.class_list) {
        if (this.class_list[i].type == 2) {
          arr.push(this.class_list[i]);
        }
      }
      this.group_list_choosed = val ? arr : [];
      this.isIndeterminateGroup = false;
    },
    handleCheckedCitiesChangeGroup(value) {
      let arr = [];
      for (let i in this.class_list) {
        if (this.class_list[i].type == 2) {
          arr.push(this.class_list[i]);
        }
      }
      let checkedCount = value.length;
      this.checkAllGroup = checkedCount === arr.length;
      this.isIndeterminateGroup = checkedCount > 0 && checkedCount < arr.length;
    },
    issues() {
      let data = {};
      data.course_src_uuid = this.work_item.course_uuid;
      data.course_name = this.work_item.name;
      data.subject_code = sessionStorage.subject_code;
      data.chapter_code = this.work_item.chapter_code;
      let arr = JSON.parse(JSON.stringify(this.creat_class_list));
      for (let i in arr) {
        arr[i].day_starttime = arr[i].day_starttime / 1000;
        arr[i].class_id = arr[i].class_id.class_id;
      }
      data.courseScheduleInfo = arr;
      this.axios.post("/school/Course_Usages/addCourseUsages", data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
          this.creat_class_list = [
            {
              class_id: { class_id: "", class_name: "" },
              course_type: "1",
              endtime: new Date(Date.parse(new Date()) + 1000 * 24 * 60 * 60),
            },
          ];
          this.slect_class_arr = [];
          this.slect_grouping_arr = [];
          this.visible = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },

    //数字装中文
    changeCharacter(num) {
      var characterArr = [
        "第一节",
        "第二节",
        "第三节",
        "第四节",
        "第五节",
        "第六节",
        "第七节",
        "第八节",
        "第九节",
        "第十节",
      ];
      return characterArr[num];
    },
    TimestampToTime_ss(data) {
      return TimestampToTime_ss(data);
    },
    TimestampToTime_weekday(data) {
      return TimestampToTime_weekday(data);
    },
    add_class() {
      this.creat_class_list.push({
        class_id: { class_id: "", class_name: "" },
        course_type: "1",
        endtime: new Date(Date.parse(new Date()) + 1000 * 24 * 60 * 60),
      });
      this.arr_to_classtable.push({ class_name: "" });
    },
    //选择上课时间子组件回调
    from_classtable(starttime, index, nodeindex, week_name) {
      // console.log(week_name)
      this.creat_class_list[this.chooseday_index].day_starttime = starttime * 1000;
      // this.creat_class_list[this.chooseday_index].endtime=starttime/1000
      this.creat_class_list[this.chooseday_index].endtime = new Date(
        starttime * 1000 + 1000 * 3600 * 24
      );
      this.creat_class_list[this.chooseday_index].node_index = nodeindex;
      this.dialogVisible_classtable = false;
      let arr = JSON.parse(JSON.stringify(this.creat_class_list));
      let arr_to_classtable = this.arr_to_classtable;
      // console.log(arr)
      for (let i in arr) {
        arr_to_classtable[this.chooseday_index] = {
          class_name: arr[i].class_id.class_name,
          index: index,
          idx: nodeindex,
          course_name: this.work_item.name,
          curent_week_name: week_name,
        };
      }
      this.arr_to_classtable = arr_to_classtable;
    },

    resetForm(form) {
      this.visible = false;
      this.$refs[form].resetFields();
      this.slect_class_arr = [];
      this.slect_grouping_arr = [];
    },

    //跳到组卷预览
    goPage(data) {
      let textbook_guid = sessionStorage.getItem("text_book_guid");
      if (data == 1) {
        window.open(
          `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${
            JSON.parse(sessionStorage.userInfo).id
          }_0&chapter_code=${this.new_tree_code_add}&chapter_name=${
            this.chapter_name
          }&textbook_guid=${textbook_guid}&from=hxb_homework&is_temporary=1`,
          "_self"
        );
      } else {
        window.open(
          `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${this.tikuCartGroupId}&chapter_code=${this.new_tree_code_add}&chapter_name=${this.chapter_name}&textbook_guid=${textbook_guid}&from=hxb_homework`,
          "_self"
        );
      }
    },
    //切换试题篮
    switchTestList(item) {
      this.tikuCartGroupName = item.name;
      this.tikuCartGroupId = item.group_id;
      this.isShowTestList = false;
      this.getTikuCartList(this.tikuCartGroupId);
    },
    switchCourseList(item) {
      this.courseCartGroupName = item.name;
      this.courseCartGroupId = item.group_id;
      this.isShowCourseList = false;
    },
    //批量删除
    batchDelTiku() {
      this.$confirm("此操作将删除此组卷篮内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          group_id: this.tikuCartGroupId,
        };
        this.axios.post("/school/cart/delTikuCart", params).then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getTikuCartList(this.tikuCartGroupId);
          }
        });
      });
    },
    //删除题型
    delCourseTiku(id) {
      this.$confirm("此操作将删除此题型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          group_id: this.tikuCartGroupId,
          type_id: id,
        };
        this.axios.post("/school/cart/delTikuCart", params).then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getTikuCartList(this.tikuCartGroupId);
          }
        });
      });
    },
    leave2() {
      //this.isShowTikuTip = false;
    },
    enter2() {
      this.isShowTip = !this.isShowTip;
      this.isShowTikuTip = !this.isShowTikuTip;
    },
    batchJoinTask() {
      let params = {
        group_id: this.tikuCartGroupId,
        tikus: [],
      };
      if (this.type_first == "cloud") {
        params.is_cloud = 1;
      } else {
        params.is_cloud = "";
      }
      for (let i in this.taskInfoList) {
        let data = {
          src_uuid: this.taskInfoList[i].uuid,
          type_id: this.taskInfoList[i].type_id,
          type_name: this.taskInfoList[i].type_name,
        };
        params.tikus.push(data);
      }
      this.axios.post("/school/cart/addTikuCart", params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },
    //加入对应试题篮
    addTikuCart(item) {
      for (let i in this.tikuLabelList) {
        if (this.tikuLabelList[i].id == item.type_id) {
          item.type_name = this.tikuLabelList[i].n;
          console.log(this.tikuLabelList[i].n);
        }
      }
      let params = {
        group_id: this.tikuCartGroupId,
        tikus: [
          {
            src_uuid: item.uuid || item.tiku_uuid,
            type_id: item.type_id,
            type_name: item.type_name,
          },
        ],
      };
      if (this.type_first == "cloud") {
        params.is_cloud = 1;
      } else {
        params.is_cloud = "";
      }
      this.axios.post("/school/cart/addTikuCart", params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },

    //获取对应试题篮列表/school/cart/tikuCartList
    getTikuCartList(id) {
      let params = {
        group_id: id,
      };
      this.axios.post("/school/cart/tikuCartList", params).then((res) => {
        if (res.data.code == 1) {
          this.tikuCartList = res.data.data.data;
          this.srcUuidsList = res.data.data.src_uuids;

          this.tikuCartListNum = res.data.data.count;
        }
      });
    },
    //获取习题篮/school/cart/tikuCartGroupList
    getTikuCartGroupList() {
      this.axios.get("/school/cart/tikuCartGroupList").then((res) => {
        if (res.data.code == 1) {
          this.tikuCartGroupList = res.data.data.data;
          this.tikuCartGroupName = this.tikuCartGroupList[0].name;
          this.tikuCartGroupId = this.tikuCartGroupList[0].group_id;
          for (let i in this.tikuCartGroupList) {
            if (this.tikuCartGroupList[i].checked == 1) {
              this.tikuCartGroupName = this.tikuCartGroupList[i].name;
              this.tikuCartGroupId = this.tikuCartGroupList[i].group_id;
            }
          }
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },

    leave() {
      //this.isShowTip = false;
    },
    enter() {
      this.isShowTip = !this.isShowTip;
      this.isShowTikuTip = false;
    },
    item_answer_show(item) {
      item.answer_show = !item.answer_show;
      this.$forceUpdate();
    },
    //发布作业
    save_assgin() {
      let homework_src_list = [
        {
          homework_src_uuid: this.homework_list.homework_uuid || this.homework_list.uuid,
          homework_name: this.homework_list.title,
          structure_type: this.structure_type,
          useage_type: this.useage_type,
        },
      ];
      let class_ids = [];
      if (this.classIds.length || this.groupIds.length) {
        for (let i in this.classIds) {
          class_ids.push(this.classIds[i]);
        }
        for (let i in this.groupIds) {
          class_ids.push(this.groupIds[i]);
        }
      } else {
        this.$message({
          type: "error",
          duration: 1500,
          message: "请选择班级",
        });
        return;
      }
      let exam_starttime;
      let endtime;
      if (this.datetime.length != 0) {
        if (typeof this.datetime[0] == "string") {
          exam_starttime = new Date(this.datetime[0]).getTime() / 1000;
          endtime = new Date(this.datetime[1]).getTime() / 1000;
        } else {
          exam_starttime = this.datetime[0].getTime() / 1000;
          endtime = this.datetime[1].getTime() / 1000;
        }
      } else {
        this.$message({
          type: "error",
          duration: 1500,
          message: "请选择作业截止时间",
        });
        return;
      }
      let correct_endtime;
      if (this.correct_endtime) {
        correct_endtime = this.correct_endtime.getTime() / 1000;
      } else {
        if (
          this.correct_type == 0 ||
          this.correct_type == 3 ||
          this.correct_type == 4 ||
          this.correct_type == 5
        ) {
        } else {
          this.$message({
            type: "error",
            duration: 1500,
            message: "请选择批改任务截止时间",
          });
          return;
        }
      }
      let data_axios = {
        subject_code: sessionStorage.subject_code,
        homework_src_list: homework_src_list,
        class_ids: class_ids.join(","),
        assigned: this.correct_type,
        exchange_end_time: correct_endtime,
        endtime: endtime,
        exam_starttime: exam_starttime,
        remark: this.homework_require,
        duration: this.limit_answer_time * 60,
        teacher_name: JSON.parse(sessionStorage.userInfo).name,
        show_answer: this.show_answer,
        structure_type: this.structure_type,
        useage_type: this.useage_type,
      };
      this.axios
        .post("/school/Homework_Usages/addHomeworkUsages2", data_axios)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
            this.saveHomeWorkDialogVisible = false;
            //重置数据
            this.correct_type = "0";
            this.correct_endtime = "";
            this.show_answer = "0";
            this.limit_answer = true;
            this.limit_answer_time = 30;
            this.correct_endtime = "";
            this.datetime = "";
            this.homework_require = "";
            this.structure_type = "0";
            this.useage_type = "1";
            this.classIds = "";
            this.groupIds = "";
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    //模糊查询
    btnsearch() {
      this.pageNum = 1;
      this.get_sourceBag();
    },

    //分页 换页
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.get_sourceBag();
    },

    //请求资源全家桶
    get_sourceBag() {
      let formData = new FormData();
      let url = "";
      if (this.type_second == "tiku") {
        formData.append("flag", this.type_first + "_" + this.type_second);
        if (this.tab_active_tree_head == 0) {
          formData.append("chapterToNode", this.str_node);
          formData.append("node_codes", "");
        } else {
          formData.append("node_codes", this.tree_code_node);
        }
      } else {
        formData.append("flag", this.type_first + "_" + this.type_second);
      }
      formData.append("order", this.order);
      formData.append("sort", this.sort);
      formData.append("name", this.searchTxt);
      formData.append("start_time", this.startTime_sort);
      formData.append("end_time", this.endTime_sort);
      formData.append("subject_code", sessionStorage.subject_code);
      formData.append("current_page", this.pageNum);
      formData.append("page_size", this.pageSize);
      formData.append("chapter_code", this.tree_code);
      if (this.type_second == "homework") {
        formData.append("homework_label_id", this.homework_label_id);
      }
      if (this.type_second == "tiku") {
        formData.append("type_id", this.tikuLabelId);
        formData.append("level", this.topicDifficulty);
      }
      if (this.type_first == "cloud") {
        url = "/teacher/subject/sourcebag";
      } else {
        url = "/school/bag/sourceBag";
      }
      this.axios.post(url, formData).then((res) => {
        if (res.data.code == 1) {
          this.isBox = false;
          if (this.type_first == "cloud") {
            this.total = res.data.data.total;
          } else {
            this.total = res.data.data.count;
          }
          this.list_resource = res.data.data.data;
          if (this.type_second == "homework") {
            for (let i in this.list_resource) {
              this.list_resource[
                i
              ].src = `static/image/${this.list_resource[i].homework_label_id}.png`;
            }
          }
          if (this.type_second == "tiku") {
            for (let i in this.list_resource) {
              if (this.list_resource[i].is_unique.indexOf("[") > -1) {
                this.list_resource[i].answer = JSON.parse(this.list_resource[i].answer);
              }
            }
          }
          this.get_tree_num();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },

    change_topic_type(id) {
      for (let i in this.tikuLabelList) {
        if (this.tikuLabelList[i].id == id) {
          return this.tikuLabelList[i].n;
        }
      }
    },

    //发送作业/导学案 资料
    issue_data(item, index) {
      this.send_item = item;
      this.class_list_choosed = [];
      this.group_list_choosed = [];
      this.choose_class_dia = true;
    },

    //创建作业
    add_homework() {
      let textbook_guid = sessionStorage.getItem("text_book_guid");
      let group_id = this.tikuCartGroupList[this.tikuCartGroupList.length - 1].group_id;
      let arr = group_id.split("_");
      window.open(
        `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${arr[0]}_${
          Number(arr[1]) + 1
        }&chapter_code=${
          this.new_tree_code_add
        }&textbook_guid=${textbook_guid}&from='homework'`,
        "_self"
      );
    },
    //选择题型难度
    switchTopicDifficulty(item, index) {
      this.switch_topicDifficulty = index;
      this.topicDifficulty = item.id;
      this.get_sourceBag();
    },
    //选择题型
    switchTikuLabel(item, index) {
      this.tikuLabelId = item.id;
      this.switch_tikuLabel = index;
      this.get_sourceBag();
    },
    getHomework(item) {
      console.log(item);
      this.pageNum = 1;
      // this.switchTab_taskLabel = 0;
      this.homework_label_id = item.id;
      this.get_sourceBag();
    },
    //选择作业类别
    switchHomeworkLabel(item, index) {
      this.pageNum = 1;
      this.switchTab_taskLabel = index;
      this.homework_label_id = item.id;
      if (item.id == 60) {
        this.isBox = true;
        this.list_resource = item.children;
      } else {
        this.get_sourceBag();
      }
    },

    //获取习题类别
    gettikuLabel() {
      let params = {
        subject_code: JSON.parse(sessionStorage.userInfo).subject_code,
      };
      this.axios.post("/teacher/subject/gettikutype", params).then((res) => {
        if (res.data.code == 1) {
          this.tikuLabelList = JSON.parse(res.data.data.type_json);
          this.tikuLabelList.unshift({ n: "全部", id: "" });
        }
      });
    },
    //获取作业类别
    getHomeworkLabel() {
      this.axios.post("/teacher/homework/gethomeworklabel").then((res) => {
        if (res.data.code == 1) {
          res.data.data.unshift({ name: "全部", id: "" });
          this.homeworkLabelList = res.data.data;
        }
      });
    },
    //作业类别是点击切换作业还是习题
    switchTabTask(item, index) {
      this.pageNum = 1;
      this.switchTab_task = index;
      if (index == 0) {
        this.type_second = "homework";
      } else {
        this.type_second = "tiku";
      }
      this.get_sourceBag();
    },
    //点击切换来源
    switchTab(item, index) {
      this.pageNum = 1;
      this.tab_active = index;
      let type_first = this.type_first;
      if (this.type_second == "homework") {
        this.homework_label_id = "";
        this.switchTab_taskLabel = 0;
      }
      if (index == 0) {
        type_first = "my";
      } else if (index == 1) {
        type_first = "share";
      } else if (index == 2) {
        type_first = "school";
      } else if (index == 3) {
        // if (this.type_second == "homework") {
        //   this.homework_label_id = "";
        //   this.switchTab_taskLabel = 0;
        // }
        type_first = "cloud";
      }
      this.type_first = type_first;
      this.get_sourceBag();
    },
    onSubmit3(item) {
      let text = "";
      if (this.type_first == "my") {
        text =
          "确定分享到学科作业？";
      }
      if (this.type_first == "share") {
        text =
          "确定分享到学校作业？";
      }
      if (this.type_first == "school") {
        text =
          "确定分享到多校作业？";
      }

      this.$confirm(`${text}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "/school/homework/changeHomeworkStatus";
          let formData = new FormData();
          formData.append("homework_id", item.homework_id||item.id);
          formData.append("flag", this.type_first + "_" + this.type_second);
          this.axios.post(url, formData).then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: "提审成功",
                duration: 1500,
                showClose: true,
              });
              this.get_sourceBag();
            }
          });
        })
        .catch(() => {});
    },
    cancel_homework(item){
      let that = this;
      this.$confirm("此操作将撤销该作业, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("homework_id", item.homework_id||item.id);
          formData.append("flag", this.type_first + "_" + this.type_second);
          this.axios.post("/school/homework/cancelHomeworkStatus", formData).then((res) => {
            if (res.data.code == 1) {
              that.$message({
                type: "success",
                message: "撤销成功",
                duration: 1500,
                showClose: true,
              });
              this.get_sourceBag();
            } else {
              that.$message({
                type: "error",
                message: res.data.msg,
                duration: 1500,
                showClose: true,
              });
            }
          });
        })
        .catch(() => {});
    },

    //预览
    preview_data(item) {
      if (this.type_first !== "cloud") {
        let params = {
          uuid: item.homework_uuid || item.uuid,
        };
        this.axios.post("/school/Homework/detail", params).then((res) => {
          if (res.data.code == 1) {
            let obj = res.data.data.data;
            this.taskInfoName = obj.title;
            let data = JSON.parse(obj.content);
            let arr = [];
            for (let i in data) {
              arr = arr.concat(data[i].topicList);
            }
            for (let index in arr) {
              if (arr[index].is_unique.indexOf("[") > -1) {
                if (arr[index].answer.indexOf('"') > -1) {
                  arr[index].answer = JSON.parse(arr[index].answer);
                } else {
                  arr[index].answer = arr[index].answer;
                }
              }
            }
            this.taskInfoList = arr;
            console.log(data);
            this.isPreviewShow = true;
          }
        });
      } else {
        let params = {
          uuid: item.homework_uuid || item.uuid,
          is_cloud: 1,
        };
        this.axios
          .post(" https://www.gaokaowin.com/proxy2/cloud/Homework/detail", params)
          .then((res) => {
            if (res.data.code == 1) {
              let obj = res.data.data.data;
              this.taskInfoName = obj.title;
              let data = JSON.parse(obj.content);
              let arr = [];
              for (let i in data) {
                arr = arr.concat(data[i].topicList);
              }
              for (let index in arr) {
                if (arr[index].is_unique.indexOf("[") > -1) {
                  if (arr[index].answer.indexOf('"') > -1) {
                    arr[index].answer = JSON.parse(arr[index].answer);
                  } else {
                    arr[index].answer = arr[index].answer;
                  }
                }
              }
              this.taskInfoList = arr;
              this.isPreviewShow = true;
            }
          });
      }
    },
    ///下载作业
    download_homework(type) {
      if (this.type_first !== "cloud") {
        let params = {
          uuid: this.homework_detail.homework_uuid || this.homework_detail.uuid,
        };
        this.axios.post("/school/Homework/detail", params).then((res) => {
          if (res.data.code == 1) {
            let obj = res.data.data.data;
            let data = JSON.parse(obj.content);
            let arr = [];

            for (let i in data) {
              arr = arr.concat(data[i].topicList);
            }
            for (let index in arr) {
              if (arr[index].is_unique.indexOf("[") > -1) {
                if (arr[index].answer.indexOf('"') > -1) {
                  arr[index].answer = JSON.parse(arr[index].answer);
                } else {
                  arr[index].answer = arr[index].answer;
                }
              }
            }

            let content = "";
            let str = "";
            let str2 = "";
            if (type == 1) {
              for (let i in arr) {
                content =
                  content + `<div>${arr[i].content}<p>${arr[i].analyzing}</p></div>`;
              }
            } else {
              for (let i in arr) {
                str = str + `<div>${arr[i].content}</div>`;
                str2 =
                  str2 +
                  `<div><p>${arr[i].analyzing ? Number(i) + 1 : ""}</p>${
                    arr[i].analyzing
                  }</div>`;
              }
              content = str + str2;
            }
            this.download(content);
          }
        });
      } else {
        let params = {
          uuid: this.homework_detail.homework_uuid || this.homework_detail.uuid,
          is_cloud: 1,
        };
        this.axios
          .post(" https://www.gaokaowin.com/proxy2/cloud/Homework/detail", params)
          .then((res) => {
            if (res.data.code == 1) {
              let obj = res.data.data.data;
              let data = JSON.parse(obj.content);
              let arr = [];
              for (let i in data) {
                arr = arr.concat(data[i].topicList);
              }
              for (let index in arr) {
                if (arr[index].is_unique.indexOf("[") > -1) {
                  if (arr[index].answer.indexOf('"') > -1) {
                    arr[index].answer = JSON.parse(arr[index].answer);
                  } else {
                    arr[index].answer = arr[index].answer;
                  }
                }
              }
              let content = "";
              let str = "";
              let str2 = "";
              if (type == 1) {
                for (let i in arr) {
                  content =
                    content + `<div>${arr[i].content}<p>${arr[i].analyzing}</p></div>`;
                }
              } else {
                for (let i in arr) {
                  str = str + `<div>${arr[i].content}</div>`;
                  str2 =
                    str2 +
                    `<div><p>${arr[i].analyzing ? Number(i) + 1 : ""}</p>${
                      arr[i].analyzing
                    }</div>`;
                }
                content = str + str2;
              }
              this.download(content);
            }
          });
      }
    },
    download(data) {
      let that = this;
      var formData = new FormData();
      formData.append("content", data);
      this.axios
        .post("/teacher/homework/changeword", formData, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          if (res.data) {
            console.log(res.data);
            that.download2(res.data, "我的作业");
          } else {
            that.$message({
              message: "错误",
              type: "error",
              duration: 500,
              showClose: true,
            });
            return false;
          }
        });
    },
    download2(data, fileName) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(
        new Blob([data], { type: "application/msword;charset=UTF-8" })
      );
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      this.homeworkDialog = false;
    },

    //取消收藏 删除
    del_data(item) {
      let that = this;
      if (this.type_second == "homework") {
        this.$confirm("此操作将删除作业, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let formData = new FormData();
            formData.append("homework_uuid", item.homework_uuid);
            this.axios
              .post("/school/Collection_homework/delCollection", formData)
              .then((res) => {
                if (res.data.code == 1) {
                  that.$message({
                    type: "success",
                    message: "删除成功",
                    duration: 500,
                    showClose: true,
                  });
                  this.get_sourceBag();
                } else {
                  that.$message({
                    type: "error",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {});
      }
      if (this.type_second == "tiku") {
        this.$confirm("此操作将删除习题, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let formData = new FormData();
            formData.append("tiku_uuid", item.uuid || item.tiku_uuid);
            this.axios
              .post("/school/Collection_tiku/delCollection", formData)
              .then((res) => {
                if (res.data.code == 1) {
                  that.$message({
                    type: "success",
                    message: "删除成功",
                    duration: 500,
                    showClose: true,
                  });
                  this.get_sourceBag();
                } else {
                  that.$message({
                    type: "error",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {});
      }
    },

    //收藏
    collection(item) {
      if (this.type_second == "homework") {
        var formData = new FormData();
        formData.append("homework_uuid", item.uuid);
        var check_src;
        check_src = 0;
        formData.append("from", item.from);
        formData.append("check_src", check_src);
        formData.append("teacher_uuid", item.teacher_uuid);
        if (this.tab_active == 3) {
          formData.append("from_cloud", 1);
        }
        this.axios
          .post("/school/Collection_homework/addCollection", formData)
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
                duration: 500,
                showClose: true,
              });
              this.get_sourceBag();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                duration: 500,
                showClose: true,
              });
            }
          });
      }
    },
    //上传作业到校本作业
    upload_homework(item, index) {
      this.axios
        .post(`/school/collection_homework/changestatus?homework_id=${item.homework_id}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    //发送作业
    issue_homework(item, index) {
      this.homework_list = item;
      let date = new Date();
      let arr = [];
      arr[0] = this.dataFormat(date.getTime());
      arr[1] = this.dataFormat(date.getTime() + 3600 * 24 * 1000);
      this.datetime = arr;
      this.saveHomeWorkDialogVisible = true;
    },

    //获取教材 章节
    getSubject(code) {
      let that = this;
      let formData = new FormData();
      formData.append("subject_code", code);
      this.axios.post("/teacher/subject/gettextbook", formData).then((res) => {
        if (res.data.data != "") {
          this.book = res.data.data;
          for (var i = 0; i < this.book.length; i++) {
            this.code.push(this.book[i].code);
            if (this.book[i].id == JSON.parse(sessionStorage.userInfo).textbook_code) {
              this.book_edit = res.data.data;
              this.changeText = res.data.data[i].name + " - " + res.data.data[i].publish;
              this.changeText_edit =
                res.data.data[i].name + " - " + res.data.data[i].publish;
              this.book_code_add = res.data.data[i].code;
              this.chapter_add_code = JSON.parse(this.book[i].chapter_json)[0].c;
              this.chapter_name = JSON.parse(this.book[i].chapter_json)[0].name;
              if (res.data.data[i].chapter_json != "") {
                let SectionData = JSON.parse(res.data.data[i].chapter_json);
                this.textbook_code = this.book[i].code;

                this.tree_code = "";
                this.SectionData = SectionData;

                for (let i in this.SectionData) {
                  this.showNode.push(this.SectionData[i].guid);
                }
                sessionStorage.SectionData = JSON.stringify(SectionData);
              } else {
                this.SectionData = [];
                this.SectionData_edit = [];
              }
              break;
            } else {
              this.book_edit = res.data.data;
              this.changeText = res.data.data[0].name + " - " + res.data.data[0].publish;
              this.changeText_edit =
                res.data.data[0].name + " - " + res.data.data[0].publish;
              this.book_code_add = res.data.data[0].code;
              if (res.data.data[0].chapter_json.length > 2) {
                this.chapter_add_code = JSON.parse(this.book[0].chapter_json)[0].c;
                this.chapter_name = JSON.parse(this.book[0].chapter_json)[0].name;
                let SectionData = JSON.parse(res.data.data[0].chapter_json);
                this.textbook_code = this.book[0].code;
                let chapter_code = "";
                for (var j in SectionData) {
                  chapter_code += j == 0 ? SectionData[j].c : "," + SectionData[j].c;
                }
                this.tree_code = "";
                this.SectionData = SectionData;
              } else {
                this.SectionData = [];
                this.SectionData_edit = [];
              }
            }
          }
          if (!this.tree_code) {
            let sectionData = localStorage.getItem("sectionData")
              ? JSON.parse(localStorage.getItem("sectionData"))
              : "";
            console.log(sectionData);
            if (sectionData) {
              this.getSectionData(sectionData);
              this.$nextTick(() => {
                that.$refs.treeBox.setCurrentKey(sectionData.guid);
              });
            } else {
              this.getSectionData(this.SectionData[0]);
              this.$nextTick(() => {
                that.$refs.treeBox.setCurrentKey(this.SectionData[0].guid);
              });
            }
          }
        } else {
          this.book = [];
          this.book_edit = [];
        }
      });
    },
    //获取考点
    getNode(code) {
      this.axios
        .get("/teacher/subject/getsubjectnode?subject_code=" + code)
        .then((res) => {
          let newData = changeData_long(res.data.data, 0);

          this.newSubject_nodeData = newData;
          for (let i in newData) {
            this.showNode_node.push(newData[i].id);
          }
        });
    },
    //根据树形筛选
    getSectionData: function (data) {
      this.getSectionData_treedata = data;
      this.new_tree_code_add = data.c;
      this.chapter_name = data.name;
      let str = getNodeCode(data, []);
      this.is_CurrentKey = data.guid;
      this.getSectionData_text = data.name;
      this.SectionData_edit = this.SectionData;
      this.chapter_add_code = this.is_CurrentKey;
      this.tree_code = str;
      let str_node = getNodeCode_topic(data, []).join(",");
      this.str_node = str_node;
      this.pageNum = 1;
      localStorage.setItem("sectionData", JSON.stringify(data));
      this.get_sourceBag();
    },
    getnewSubject: function (data) {
      this.is_CurrentKey_node = data.guid;
      this.tree_code_node = data.code;
      this.pageNum = 1;
      this.get_sourceBag();
    },
    //递归获取所有子章节编码
    get_child_chapter_code(all_chapter, current_code) {
      let chapter_code_temp = "",
        temp;
      for (var i in all_chapter) {
        if (all_chapter[i].p_c == current_code) {
          chapter_code_temp += "," + all_chapter[i].c;
          temp = this.get_child_chapter_code(all_chapter, all_chapter[i].c);
          if (temp != "") {
            chapter_code_temp += temp;
          }
        }
      }
      return chapter_code_temp;
    },
    change_sort_time_homework(type) {
      this.popover_sort_show_homework = false;
      this.sort_time_homework = type;
      this.sort_getdata_homework();
    },
    change_sort_type_homework(type) {
      this.popover_sort_show_homework = false;
      this.sort_type_homework = type;
      this.sort_getdata_homework();
    },

    // 2.0 排序
    change_sort_time(type) {
      this.popover_sort_show = false;
      this.sort_time = type;
      this.sort_getdata();
    },
    change_sort_type(type) {
      this.popover_sort_show = false;
      this.sort_type = type;
      this.sort_getdata();
    },
    sort_getdata() {
      let timestamp = Date.parse(new Date());
      if (this.sort_time == "全部") {
        this.startTime_sort = "";
        this.endTime_sort = "";
      } else if (this.sort_time == "最近一周") {
        this.startTime_sort = timestamp - 1000 * 7 * 24 * 60 * 60;
        this.endTime_sort = timestamp;
      } else if (this.sort_time == "最近一月") {
        this.startTime_sort = timestamp - 1000 * 30 * 24 * 60 * 60;
        this.endTime_sort = timestamp;
      } else if (this.sort_time == "最近一年") {
        this.startTime_sort = timestamp - 1000 * 365 * 24 * 60 * 60;
        this.endTime_sort = timestamp;
      }
      if (this.sort_type == "时间最新") {
        this.order = "descending";
        this.sort = "createtime";
      } else if (this.sort_type == "时间最早") {
        this.order = "ascending";
        this.sort = "createtime";
      } else if (this.sort_type == "热度最高") {
        this.order = "descending";
        this.sort = "heat";
      }

      this.get_sourceBag();
    },
    sort_getdata_homework() {
      let timestamp = Date.parse(new Date());
      if (this.sort_time_homework == "全部") {
        this.startTime_sort_homework = "";
        this.endTime_sort_homework = "";
      } else if (this.sort_time_homework == "最近一周") {
        this.startTime_sort_homework = timestamp - 1000 * 7 * 24 * 60 * 60;
        this.endTime_sort_homework = timestamp;
      } else if (this.sort_time_homework == "最近一月") {
        this.startTime_sort_homework = timestamp - 1000 * 30 * 24 * 60 * 60;
        this.endTime_sort_homework = timestamp;
      } else if (this.sort_time_homework == "最近一年") {
        this.startTime_sort_homework = timestamp - 1000 * 365 * 24 * 60 * 60;
        this.endTime_sort_homework = timestamp;
      }
      if (this.sort_type_homework == "时间最新") {
        this.order_homework = "descending";
        this.sort_homework = "createtime";
      } else if (this.sort_type == "时间最早") {
        this.order_homework = "ascending";
        this.sort_homework = "createtime";
      } else if (this.sort_type_homework == "热度最高") {
        this.order_homework = "descending";
        this.sort_homework = "heat";
      }
      this.get_my_unwork_List();
    },

    //获取周几
    getweekdata(item) {
      if (item.day_starttime) {
        let arr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
        return arr[new Date(item.day_starttime).getDay()];
      }
    },

    //获取全部类型
    get_data_all_type() {
      let formData = new FormData();
      if (sessionStorage.userInfo) {
        formData.append("subject_code", JSON.parse(sessionStorage.userInfo).subject_code);
      }
      this.axios.post(`/teacher/course/getcourselabel`, formData).then((res) => {
        if (res.data.code == 1) {
          var arr_list = [{ name: "全部", id: "" }];
          for (var i = 0; i < res.data.data.length; i++) {
            arr_list.push(res.data.data[i]);
          }
          this.all_types = arr_list;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    //获取班级信息
    get_class_list() {
      this.axios.post("/school/Classes/detail").then((res) => {
        if (res.data.code == 1) {
          var arr = res.data.data.data;
          this.class_list = arr;
          let classList = [];
          let groupingList = [];
          for (let i in arr) {
            if (arr[i].type == 1) {
              classList.push(arr[i]);
            }
            if (arr[i].type == 2) {
              groupingList.push(arr[i]);
            }
          }
          this.groupingList = groupingList;
          this.classList = classList;
          this.allClassList = classList.concat(groupingList);
          console.log(this.allClassList);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    //获取教材考点习题类型
    get_type() {
      var code = sessionStorage.subject_code;
      this.axios.get("/teacher/subject/getlist?subject_code=" + code).then((res) => {
        if (res.data.code == 1) {
          var list = JSON.parse(res.data.data.tiku_type.type_json);
          this.question_type = [];
          for (var i = 0; i < list.length; i++) {
            this.question_type.push(list[i]);
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 500,
            showClose: true,
          });
        }
      });
    },
    //删除
    uncollect(id) {
      var formData = new FormData();
      formData.append("material_uuid", id);

      this.axios
        .post("/school/Collection_Material/delCollection", formData)
        .then((res) => {
          this.get_sourceBag();
        });
    },
    //云管理员收藏到云
    collect_tocloud(uuid) {
      // console.log(uuid)
      let formData = new FormData();
      formData.append("uuid", uuid);
      // formData.append("subject_code", this.userInfo.subject_code);
      formData.append("schoolcode", this.userInfo.school_code);
      this.axios.post("/teacher/collect/material", formData).then((res) => {
        // console.log(res)
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "已添加到云端",
            duration: 1500,
            showClose: true,
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
  },
  created() {
    this.options_add_material.target =
      JSON.parse(sessionStorage.userInfo).school.server_url + "/school/common/zoneupload";
  },

  beforeDestroy() {
    bus.$off("sendSubject_code");
    this.$store.state.data_save_course = this.$data;
  },
};
</script>

<style>
.assign_homework_choose_class_dia {
  width: 660px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
}

.assign_homework_choose_class_dia .el-dialog__footer {
  text-align: center !important;
}

.homework_edit_choose_topic .el-dialog__footer {
  text-align: center !important;
}

.add_course_info_head_course_name_add_name .el-input__inner {
  border-color: transparent !important;
  background: #f3f3f3;
  border-radius: 20px 0px 20px 2px;
  text-align: center;
  font-size: 16px !important;
  height: 40px !important;
}

.add_course_info_head_course_name_add_name.el-checkbox__label {
  font-size: 12px !important;
}

.area_popper .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}

.area_popper {
  border-color: #ff9b36;
  width: 300px;
  height: 400px;
  padding-right: 0;
  overflow: auto;
  font-size: 16px;
  line-height: 16px;
}

.homework_edit_choose_topic {
  width: calc(100vw - 720px);
  border-radius: 12px;
  /* height: 90vh; */
  overflow: hidden;
  margin-top: 5vh !important;
}

.homework_edit_choose_topic .el-dialog__body {
  background: #f2f2f2;
}

.add_course_info_head_course_name_add_name .el-input__inner {
  border-color: transparent !important;
  background: #f3f3f3;
  border-radius: 20px 0px 20px 2px;
  text-align: center;
  font-size: 16px !important;
  height: 40px !important;
}

.add_course_info_head_course_name_add_name.el-checkbox__label {
  font-size: 12px !important;
}

.dialogVisible_add_material {
  border-radius: 20px;
}

.dialogVisible_add_material .el-dialog__footer {
  text-align: center;
}

.dialogVisible_add_material .el-dialog__footer .el-button {
  margin: 0 50px;
}

.labe_wd .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.labe_wd .el-input__icon {
  /* height: 36px !important; */
  line-height: 38px !important;
}

.send_course_dia {
  border-radius: 20px;
}

.course_search .el-input-group__append {
  border-radius: 0 20px 20px 0;
}

.course_search .el-input__inner {
  border-radius: 20px 0 0 20px;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 16px !important;
}

.course_search .el-input {
  height: 40px;
}

.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}

.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}

.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}

.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}

.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}

.color_active {
  color: #ff9b36 !important;
}
</style>

<style scoped>
.add_course_info_head_course_name_add_name {
  align-items: center;
}

.add_course_info_head_course_name_add_name > div:nth-of-type(1) {
  width: 120px;
}

.subject_main {
  overflow: hidden;
}

.wrapper {
  margin: 14px auto;
  width: 75vw;
  display: flex;
  justify-content: space-between;
  /* background: white; */
  height: calc(100vh - 206px);
  overflow: hidden;
}

.pageNav {
  width: 75vw;
  height: 54px;
  margin: 0 auto;
  margin-top: 14px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  padding: 0px 10px;
  position: relative;
}

.mar_right {
  margin-right: 150px;
}

.pageNavTitle {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
}

.pageNavLine {
  width: 64px;
  height: 4px;
  background: #54a9fd;
  border-radius: 2px;
}

.activePageNavTitle {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #54a9fd;
}

.chapter_tree_box {
  width: 432px;
  /* height:100%; */
  /* overflow: auto; */
  /* padding: 10px; */
  /* background: #ffffff; */
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;
  margin-right: 10px;
  box-sizing: border-box;
}

.chapter_tree_box_head_none {
  height: 1px;
}

.chapter_tree_box_trees {
  flex: 1;
  overflow: auto;
  padding: 10px 0;
  background: #ffffff;
  border-radius: 12px;
}

.chapter_tree_box_head {
  /* height: 60px; */
  box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
  border-radius: 12px;
  margin-bottom: 16px;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  height: 30px;
  padding: 15px 0;
  text-align: center;
}

.chapter_tree_box_head > div {
  cursor: pointer;
}

.tree_line {
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  padding-right: 15px;
}

.tree_line > div:nth-of-type(1) {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content {
  width: 810px;
  /* background: #ffffff; */
  border-radius: 12px;
  /* padding-bottom: 10px; */
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  flex: 1;
}

.content_head {
  margin-bottom: 14px;
}

.content_head_nav {
  width: 85%;
  padding: 0px 26px 0px 26px;
  background: #ffffff;
  border-radius: 12px;
  height: 52px;
}

.content_head_btn {
  width: 90px;
  height: 52px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9b36;
  cursor: pointer;
  margin-left: 14px;
}

.content_head_nav_item {
  position: relative;
}

.content_head_nav_item span {
  cursor: pointer;
  font-size: 16px;
}

.course_type_line {
  width: 36px;
  height: 0.15vw;
  background: #54a9fd;
  border-radius: 3px;
  margin: 3px auto;
  opacity: 1;
  position: absolute;
  bottom: -8px;
}

.course_type_line_hide {
  width: 36px;
  height: 5px;
  background: #54a9fd;
  border-radius: 3px;
  margin: 3px auto;
  opacity: 0;
}

.active_color {
  color: #69b4ff;
}

.content_nav {
  padding: 15px;
  padding-bottom: 0;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 14px;
}

.content_nav_item {
  margin-bottom: 15px;
}

.content_nav_item_btn {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  margin-right: 25px;
  padding: 3px 10px;
  /* min-width: 62px; */
}

.content_nav_item_btn_active {
  border: 1px solid #69b4ff;
  border-radius: 13px;
  color: #6ab4f8;
}

.content_box {
  background: #ffffff;
  border-radius: 12px;
}

.content_list {
  height: calc(100% - 50px);
}

.course_box_head {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
  margin: 14px 16px 14px 18px;
  height: 40px;
}

.course_search {
  height: 40px;
}

.course_creat_sort {
  display: flex;
  justify-items: center;
}

.content_listBox_item {
  padding: 16px;
  /* border: 4px solid #69b4ff; */
  border: 3px solid #f6f6f6;
  box-shadow: 0px 4px 4px 0px #ececec;
  border-radius: 6px 20px 20px 6px;
  /* height: 264px;
		overflow: hidden; */
  margin-bottom: 14px;
  cursor: pointer;
  padding-bottom: 10px;
}

.content_listBox_item:hover {
  border: 3px solid #69b4ff;
}

.content_listBox {
  padding: 5px 18px;
}

.content_item_icon {
}

.content_item_icon img {
  width: 63px;
  height: 65px;
}

.content_item_info {
  margin-left: 13px;
}

.content_item_info p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 0;
}

.mr23 {
  margin-right: 23px;
}
.btn3Box {
  position: absolute;
  right: 10px;
}

.content_item_btnBox {
  margin-top: 10px;
  float: right;
}

.content_item_btnBox_item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  cursor: pointer;
  margin-right: 35px;
}

.content_item_btnBox_item img {
  width: 17px;
  height: 17px;
  margin-right: 7px;
}

.color999 {
  color: #999999;
}

.dataBag {
  width: 70px;
  height: 160px;
  background: #ff9b36;
  border-radius: 0px 20px 20px 0px;
  position: fixed;
  top: 65%;
  margin-left: 988px;
  cursor: pointer;
}

.dataBag img {
  width: 34px;
  height: 35px;
  margin-top: 39px;
}

.dataBag span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.testQuestions {
  position: fixed;
  top: 60%;
  margin-left: 998px;
  cursor: pointer;
}

.dataBagBox2 {
  position: fixed;
  top: 40%;
  margin-left: 1445px;
  cursor: pointer;
}

.dataBagBox {
  position: fixed;
  top: 40%;
  margin-left: 998px;
  cursor: pointer;
}

.dataBag2 {
  width: 70px;
  height: 160px;
  background: #ff9b36;
  border-radius: 0px 20px 20px 0px;
  margin-right: 3px;
}

.dataBag2 img {
  width: 34px;
  height: 35px;
}

.dataBag2 span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.testQuestions2 {
  position: fixed;
  top: 60%;
  margin-left: 1445px;
  cursor: pointer;
}

.testQuestions2 img {
  width: 34px;
  height: 35px;
  margin-top: 20px;
  margin-bottom: 5px;
}

.testQuestions2 span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.testQuestionsBox {
  width: 70px;
  height: 160px;
  background: #69b4ff;
  border-radius: 0px 20px 20px 0px;
  margin-right: 3px;
}

.testQuestions img {
  width: 34px;
  height: 35px;
  margin-top: 20px;
  margin-bottom: 5px;
}

.testQuestions span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.testBtn {
  width: 70px;
  height: 23px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  box-shadow: 0px 1px 8px 0px rgba(63, 145, 227, 0.35);
  border-radius: 0px 12px 0px 0px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  cursor: pointer;
}

.testBtn2 {
  width: 70px;
  height: 23px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  box-shadow: 0px 1px 8px 0px rgba(63, 145, 227, 0.35);
  border-radius: 0px 12px 0px 0px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9b36;
  cursor: pointer;
}

.numClass2 {
  padding: 1px 10px;
  margin-top: 8px;
  line-height: 16px;
  color: #fff;
  font-size: 12px;
}

.numClass {
  padding: 1px 10px;
  margin-top: 8px;
  line-height: 16px;
  background-color: #ff4848;
  border-radius: 8px;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  color: #fff;
  font-size: 12px;
}

.content_item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  height: 40px;
  line-height: 40px;
}

.content_item_title {
  width: 110px;
  text-align: left;
  margin-right: 10px;
}

.assign_type {
  height: 32px;
  background: #f3f3f3;
  border-radius: 8px;
  line-height: 32px;
  padding: 0 20px;
  color: #666666;
  cursor: pointer;
  margin: 0 9px 0 24px;
}

.icon_question {
  color: #cccccc;
  cursor: pointer;
  font-size: 16px;
}

.assign_type:active {
  background: #69b4ff !important;
  color: #ffffff !important;
}

.assign_type:hover {
  background: #69b4ff !important;
  color: #ffffff !important;
}

.assign_type_active {
  background: #69b4ff !important;
  color: #ffffff !important;
}

.homework_list {
  width: 360px;
  background: #f4faff;
  border-radius: 20px 2px 20px 2px;
  margin-left: 120px;
  padding: 0 24px;
  overflow: auto;
}

.homework_list_item {
  display: flex;
  height: 18px;
  line-height: 18px;
  align-items: center;
  margin: 24px 0;
}

.homework_list_item img {
  display: block;
  width: 22px;
  height: 18px;
  margin-right: 12px;
}

.homework_list_item_close {
  display: block;
  margin-left: auto;
  cursor: pointer;
  font-size: 16px;
  color: #666666;
}

.content_item_btn {
  height: 32px;
  background: #ff9b36;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  padding: 0 20px;
  cursor: pointer;
}

.class_list {
  margin-left: 120px;
}

.homework_list_item_group_icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  background: #ff9b36;
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
  margin-right: 12px;
}

.homework_list_item_class_icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  background: #69b4ff;
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
  margin-right: 12px;
}

.correct_set {
  margin-left: 48px;
  width: 160px !important;
}

.correct_set_time {
  margin-left: 68px;
  width: 80px !important;
}

.content_item_margin {
  margin: 20px 0 !important;
}

.class_list_choose {
  background: #f8f8f8;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  padding: 16px 20px;
}

.choose_group_title {
  margin-top: 16px;
}

.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.topic_list_item {
  padding: 16px;
  /* border: 4px solid #69b4ff; */
  border: 3px solid #f6f6f6;
  box-shadow: 0px 4px 4px 0px #ececec;
  border-radius: 6px 20px 20px 6px;
  /* height: 264px;
		overflow: hidden; */
  margin-bottom: 14px;
  cursor: pointer;
  padding-bottom: 10px;
}

.topic_list_item:hover {
  border: 3px solid #69b4ff;
}

.topic_list_item2 {
  padding: 16px;
  /* border: 4px solid #69b4ff; */
  border: 3px solid #f6f6f6;
  box-shadow: 0px 4px 4px 0px #ececec;
  border-radius: 6px 20px 20px 6px;
  /* height: 264px;
		overflow: hidden; */
  margin-bottom: 14px;
  cursor: pointer;
  padding-bottom: 10px;
}

.topic_list_item2:hover {
  border: 3px solid #69b4ff;
}

.topic_txt span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  display: inline-block;
  margin-right: 10px;
}

.topic_Btn img {
  width: 15px;
  height: 16px;
  margin-right: 9px;
}

.topic_btnItem {
  padding: 8px 14px;
  background: #69b4ff;
  border-radius: 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-left: 20px;
}

.topic_answer_analyzing {
  border: 1px solid #69b4ff;
  border-radius: 8px;
  padding: 13px;
}

.topic_answer_analyzing2 {
  border: 1px solid #ff9b36;
  border-radius: 8px;
  padding: 13px;
}

.tip {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 60%;
  margin-left: 680px;
  padding: 13px;
  /* overflow-x:hidden ; */
  /* overflow-y:scroll ; */
}

.tip2 {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 60%;
  margin-left: 1130px;
  padding: 13px;
  /* overflow-x:hidden ; */
  /* overflow-y:scroll ; */
}

.trangle {
  width: 0px;
  height: 0px;
  border: 14px solid #000;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #69b4ff;
  border-right-color: transparent;
  position: absolute;
  right: -28px;
  top: 80px;
}

.tipHead span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.tipItem {
  margin-bottom: 17px;
}

.tipItemList {
  margin-bottom: 10px;
}

.tipItemName {
  width: 130px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  margin-right: 5px;
}

.tipBtn {
  padding: 12px 9px;
  background: #ff9b36;
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
  width: 150px;
  margin: 0 auto;
}

.tipTiku {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 60%;
  margin-left: 690px;
  padding: 13px;
}

.tipTiku2 {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 60%;
  margin-left: 1130px;
  padding: 13px;
}

.tikuListItem {
  margin-bottom: 16px;
}

.tikuTypeName {
  width: 100px;
}

.testList {
  width: 70px;
  background: #f9fcff;
  padding: 5px 0px;
  visibility: hidden;
  max-height: 160px;
  overflow-y: auto;
  box-sizing: border-box;
}

.isShowTestList {
  visibility: visible;
}

.testListItem {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin: 3px 0;
  cursor: pointer;
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.testListItemActive {
  color: #69b4ff;
}

.previewListBox {
  background: #ffffff;
  border-radius: 12px;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0px 15px;
}

.previewListBoxHead {
  padding: 15px 0px;
}

.backIcon img {
  width: 24px;
  height: 20px;
  cursor: pointer;
}

.previewBtn {
  padding: 9px 11px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #69b4ff;
  border-radius: 8px;
  cursor: pointer;
}

.course_card_empty {
  background: url(../../assets/images/course_2.0/老师.png);
  width: 100%;
  height: 80%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 200px auto;
}

.creat_course {
  /* width: 78px; */
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
}

.add_material_contnet {
  padding: 0 20px;
}

.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}

.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}

.add_material_content_btn {
  margin: 10px 0;
}

.uploader-drop {
  border: 0 !important;
  background-color: transparent;
  padding: 0;
  margin: 0 0 10px 0;
}

.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.edit_material_item_type_name {
  margin-bottom: 20px;
}

.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
}

.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 30px 0;
}

.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}

.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}

.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}

.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 35px;
  height: 42px;
  margin: 28px auto;
}

.add_course_info_content_box_content_item_img_teaching {
  display: block;
  width: 44px;
  height: 47px;
  margin: 26px auto;
}

.add_course_info_content_box_content_item_txt {
  width: 120px;
  height: 35px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}

.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}

.content_listBox_Img img {
  width: 58px;
  height: 60px;
  margin-right: 16px;
}

.content_listBox_title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}

.content_listBox_txt {
  margin-right: 8px;
  font-size: 12px !important;
}

.marin_bottom {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  line-height: 32px;
}

.choosed_time {
  height: 32px;
  border: 1px solid #ff9b36;
  box-shadow: 0px 0px 4px 0px #fe8b17;
  border-radius: 8px;
  line-height: 32px;
  text-align: center;
  /* margin-top: 10px; */
  padding-right: 10px;
  color: #ff9b36;
}

.marin_bottom > div:nth-of-type(2) {
  height: 32px;
  background: #69b4ff;
  border-radius: 8px;
  padding: 0 18px;
  line-height: 32px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.confirm_cancel {
  display: flex;
  justify-content: space-between;
}

.labe_wd {
  height: 180px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 14px;
  /* box-sizing: border-box; */
  margin-bottom: 20px;
  position: relative;
  border: 1px solid #dfdfdf;
}

.choose_course_time {
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  padding: 0 14px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  color: #ffffff;
}

.tikuName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  padding: 0px 5px;
}

.homeWorkBox {
  background: #ffffff;
  border-radius: 12px;
  height: 100%;
  width: 100%;
}

.homeWorkHead {
  padding: 14px;
}

.homeWorkContent {
  padding: 5px 15px;
}

.homeWorkItem {
  background: #ffffff;
  box-shadow: 0px 1px 6px 0px #cccccc;
  border-radius: 12px;
  margin-bottom: 20px;
}

.homeWorkItemFooter {
  height: 36px;
  background: #f7f7f7;
  border-radius: 12px;
  padding: 0px 31px;
}

.homeWorkItemFooterBtn {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #54a9fd;
}

.homeWorkItemFooterTxt {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
}

.marginRight36 {
  margin-right: 36px;
}

.homeWorkItemContent {
  padding: 24px 32px;
}

.homeWorkItemBtn {
  width: 100px;
  height: 40px;
  background: #54a9fd;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.homeWorkItemBtn2 {
  width: 100px;
  height: 40px;
  background: #ff9b36;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.homeWorkItemContentImg img {
  width: 68px;
  height: 76px;
  margin-right: 39px;
}

.homeWorkItemContentTitle {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-right: 16px;
}

.homeWorkItemContentStatus {
  width: 64px;
  height: 24px;
  background: #ff9b36;
  border-radius: 4px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.marginBottm25 {
  margin-bottom: 25px;
}

.homeWorkItemContentTxt {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin-right: 72px;
}

.creatBtn {
  position: absolute;
  right: 10px;
}

.homeWorkItemBtn3 {
  width: 100px;
  height: 40px;
  background: #f56c6c;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.homeworkDialogBox {
  width: 345px;
  height: 600px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding: 10px;
}

.homeworkDialogBoxItem {
  width: 267px;
  /* height: 36px;
  background: #f3f3f3;
  border-radius: 12px 0px 12px 2px; */
  margin-left: 5px;
}

.btn {
  width: 100px;
  height: 36px;
  background: #69b4ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.btn2 {
  width: 100px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  cursor: pointer;
}

.boxContent {
  border: 1px dashed gray;
  padding: 5px;
  margin-bottom: 5px;
}

.saveBox {
  display: flex;
  flex-direction: column;
  height: calc(75vh - 120px);
  overflow: auto;
}

.btn3 {
  width: 90px;
  height: 36px;
  /* background: #ff9b36; */
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9b36;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
  border: 1px solid #ff9b36;
}
</style>
